import React from "react";
import BarcodeReader from "react-barcode-reader";
import {
  Modal,
  Input,
  Form,
  Select,
  Icon,
  DatePicker,
  Tabs,
  Button,
  Tag,
  message,
  Checkbox,
  Radio,
  Spin
} from "antd";
import moment from "moment";
import "./styles.css";

import {
  FORMAT_NUMBER,
  FORMAT_3DECIMALS,
} from "../../../common/types/regularExpresionType";
import {
  FACTURA,
  BOLETA_DE_VENTA
} from "../../../common/types/tipoComprobanteType";

import Productos from "./FormModal/Productos";
import Referencias from "./FormModal/Referencias";
import Footer from "./FormModal/Footer";
import auth from "../../../common/utility/auth";
import global from "../../../common/utility/global";
import dialog from "../../../common/utility/dialog";

import {
  VENTA_PRECIO_UNITARIO_INCLUYE_IGV,
  IMPUESTO_SELECTIVO_CONSUMO_VENTA,
  PORCENTAJE_PERCEPCION,
  VALIDAR_STOCK,
  VENTA_DECIMAL,
  SERIE_POR_PRODUCTO,
  PROY_AGRO
} from "../../../common/types/parametroType";
import Cuotas from "./FormModal/Cuotas";
import MetodoPago from "./FormModal/MetodoPago";

import { CONTADO, CREDITO } from "../../../common/types/formaPagoType";
import { SOLES } from "../../../common/types/monedaType";
import { GENERAR_CNTINGENCIA, EDITAR_FECHA } from '../../../common/types/configuracionType';
import { lst_tipo_impuesto } from "../../../common/types/impuestoType";

const InputGroup = Input.Group;
const { Search } = Input;
const { Option } = Select;
const { TabPane } = Tabs;

class FormModal extends React.Component {
  // constructor(props) {
  //   super(props);
  //   this.state = {
  //   };
  // }

  constructor(props) {
    super(props);
    this.state = {
      result: "No result",
      flagTributosIguales: false,
      isMobile: this.esMobil(),
    };

    this.handleScan = this.handleScan.bind(this);

  }

  esMobil() {
    return navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/iPad/i) ||
      navigator.userAgent.match(/webOs/i) ||
      navigator.userAgent.match(/iPod/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/BlackBerry/i) ||
      navigator.userAgent.match(/Windows Phone/i)
  }

  handleScan(data) {
    this.props.onScanerProduct(
      data,
      this.props.form.setFieldsValue,
      this.props.form.getFieldValue,
      this.handleCalculateDetail
    );
  }
  handleError(err) {
    alert("error");
    console.error(err);
  }

  handleEnviado() {
    return false;
  }


  serieCustomValidation = (rule, value, callback) => {
    if (this.props.formValues.flagContingencia) callback();

    if (this.props.formValues.idTipoComprobante === FACTURA.ID) {
      if (
        value !== undefined &&
        value !== null &&
        value.length > 0 &&
        !value.toUpperCase().includes("F")
      )
        callback("Serie no válida");
    } else if (this.props.formValues.idTipoComprobante === BOLETA_DE_VENTA.ID) {
      if (
        value !== undefined &&
        value !== null &&
        value.length > 0 &&
        !value.toUpperCase().includes("B")
      )
        callback("Serie no válida");
    } else {
      if (
        this.props.form.getFieldValue("idTipoComprobanteImportado") ===
        FACTURA.ID &&
        !value.toUpperCase().includes("F")
      )
        callback("Serie no válida");

      if (
        this.props.form.getFieldValue("idTipoComprobanteImportado") ===
        BOLETA_DE_VENTA.ID &&
        !value.toUpperCase().includes("B")
      )
        callback("Serie no válida");
    }

    callback();
  };

  documentoCustomValidation = (rule, value, callback) => {
    if (value === "00000000") callback("Documento no válido");

    callback();
  };


  completeDocumento = (e) => {
    var value = e.target.value;
    if (value.length === 0) return;

    var zeros = "";
    for (let index = 0; index < 8 - value.length; index++) {
      zeros += "0";
    }
    this.props.form.setFieldsValue({ documento: zeros + value }, () => {
      this.props.form.validateFields(["documento"], { force: true });
    });
  };

  findDaysAndDates = (property, value) => {
    if (property === "diasVencimiento") {
      const fecha = moment(
        this.props.form.getFieldValue("fechaStr"),
        "DD/MM/YYYY"
      );
      const diasVencimiento = parseInt(value);
      this.props.form.setFieldsValue({
        fechaVencimientoStr: fecha.add("days", diasVencimiento),
      });
    }

    if (property === "fechaVencimientoStr") {
      const fecha = moment(
        this.props.form.getFieldValue("fechaStr"),
        "DD/MM/YYYY"
      );
      const fechaVencimiento = moment(value, "DD/MM/YYYY");
      this.props.form.setFieldsValue({
        diasVencimiento: fechaVencimiento.diff(fecha, "days").toString(),
      });
    }
  };

  handleSearchAutocompleteCliente = async (value) => {
    /*     const result = this.props.formValues.clientes
          .filter((item) => {
            return global
              .formatSearch(`${item.nombre} - ${item.tipoDocumentoNombre}`)
              .match(global.formatSearch(value));
          })
          .slice(0, 75); */

    this.props.fetchClientes(value, this.props.form)
    //this.props.form.setFieldsValue({ clientes: result });
  };

  handleChangeAutocompleteCliente = (a, element) => {

    this.props.form.setFieldsValue(
      {
        documentoCliente: element.props.data.numeroDocumento,
      },
      () => {
        this.props.onChange(
          "idCliente",
          element.props.data.idEntidad + "-" + element.props.data.id,
          this.props.form
        );
      }
    );
  };

  handleCompleteDecimals = (property, value) => {
    if (value === "" || isNaN(parseFloat(value).toFixed(3)))
      this.props.form.setFieldsValue({ [property]: "0.000" });
    else
      this.props.form.setFieldsValue({
        [property]: parseFloat(value).toFixed(3),
      });
  };

  handleCalculateDetail = (row, property, value, numberDecimals, index) => {

    if (value === "") {
      value = 0;
    }
    var newValue = this.fetchNewValue(value, numberDecimals);
    var params = auth.user().parametros;

    /********* Datos de parametro ******/
    const precioVenta = params.filter(m => m.abreviatura === VENTA_DECIMAL)[0].valor === "1" ? 2 : 5;
    const cantidadVenta = params.filter(m => m.abreviatura === VENTA_DECIMAL)[0].valor === "1" ? 2 : 3;

    var otroImpuesto = this.props.form.getFieldValue("otroImpuesto");
    var porcentajeIGV = lst_tipo_impuesto.find(item => item.id === otroImpuesto?.key)?.value ?? 18;

    var porcentajeISC = parseFloat(
      params.filter(
        (m) => m.abreviatura === IMPUESTO_SELECTIVO_CONSUMO_VENTA
      )[0].valor
    );
    var flagPrecioIncluyeIGV =
      params.filter(
        (m) => m.abreviatura === VENTA_PRECIO_UNITARIO_INCLUYE_IGV
      )[0].valor === "1"
        ? true
        : false;

    var flagValidarStock =
      params.filter((m) => m.abreviatura === VALIDAR_STOCK)[0].valor === "1"
        ? true
        : false;

    /*********** Datos por fila ********/


    var flagAfecto = false;
    var flagExonerado = false;
    var flagGratuito = false;
    var flagISC = false;

    var flagChangeTotal = false;

    var getImpuesto =
      property === "arridImpuesto"
        ? value
        : this.props.form.getFieldValue(`arridImpuesto[${row.identifier}]`).key;


    const selectedImpuesto = this.props.formValues.tipoAfectacion.find(x => x.id === getImpuesto);

    const DEFAULT_CODIGO = '10';
    const codigo = selectedImpuesto?.codigoSunat ?? DEFAULT_CODIGO;

    switch (true) {

      // Gravado
      case ["10", "17"].includes(codigo):
        flagAfecto = true;
        break;

      // Exonerado
      case codigo === "20":
        flagExonerado = true;
        break;

      // Inafecto
      case codigo === "30":
        break;

      // Exportación
      case codigo === "40":
        break;
    }

    var precioUnitario = this.fetchFieldValue(row.identifier, "arrPrecioUnitario");
    var valorUnitario = this.fetchFieldValue(row.identifier, "arrValorUnitario");


    // Si se está editando el valor unitario
    if (property === "arrValorUnitario") {
      // Asegurarse que el valor ingresado sea un número válido
      const parsedValorUnitario = parseFloat(value);
      if (!isNaN(parsedValorUnitario)) {
        precioUnitario = flagAfecto ? parsedValorUnitario * 1.18 : valorUnitario;

      }
    }
    if (property === "arrPrecioUnitario") {
      // Asegurarse que el valor ingresado sea un número válido
      const parsedPrecioUnitario = parseFloat(value);
      if (!isNaN(parsedPrecioUnitario)) {
        valorUnitario = flagAfecto ? parsedPrecioUnitario / 1.18 : precioUnitario;
      }
    }

    var cantidad = this.fetchFieldValue(row.identifier, "arrCantidad");
    if (property === "arrCantidad") {
      cantidad = parseFloat(value);
    }

    var porcentajeMargenComercial = this.fetchFieldValue(row.identifier, "arrPorcentajeMargenComercial");

    var precioPromedio = this.fetchFieldValue(row.identifier, "arrPrecioPromedio");


    var porcentajeDescuento = this.fetchFieldValue(
      row.identifier,
      "arrPorcentajeDescuento"
    );
    var importeDescuento = this.fetchFieldValue(
      row.identifier,
      "arrImporteDescuento"
    );
    var total = this.fetchFieldValue(row.identifier, "arrTotal");
    var UnidadMedida = this.props.form.getFieldValue(`arridUnidadMedida[${row.identifier}]`).key;
    var LstUnidadMedida = this.props.formValues.unidadesMedida.filter((m) => m.nombre == UnidadMedida);
    var idUnidadMedida = LstUnidadMedida.length == 0 ? UnidadMedida : LstUnidadMedida[0].id;

    /*********** VALIDACION DE CAMPOS ********/

    if (isNaN(parseFloat(precioUnitario)) || precioUnitario === "") {
      precioUnitario = 0;
      valorUnitario = 0;
    }

    if (isNaN(parseFloat(cantidad)) || cantidad === "") {
      cantidad = 0;
    }

    if (isNaN(parseFloat(importeDescuento)) || importeDescuento === "") {
      importeDescuento = 0;
    }

    if (isNaN(parseFloat(porcentajeDescuento)) || porcentajeDescuento === "") {
      porcentajeDescuento = 0;
    }

    if (isNaN(parseFloat(total)) || total === "") {
      total = 0;
    }

    if (porcentajeDescuento > 100) {
      message.warning("El porcentaje de descuento no puedo ser mayor a 100%");
      return;
    }

    /*********** VALIDACION CASOS EXONERADOS INAFECTOS ********/


    if (property == "arridUnidadMedida") {
      idUnidadMedida = value;
    }
    /*********** Datos por fila (bloquear checks) ********/
    if (flagGratuito && property == "arrFlagGratuito") {
      flagAfecto = false;
      flagISC = false;
      flagExonerado = false;
    }

    if (flagAfecto && property == "arrFlagAfecto") {
      flagGratuito = false;
      flagExonerado = false;
      flagISC = false;
    }

    if (flagExonerado && property == "arrFlagExonerado") {
      flagAfecto = false;
      flagGratuito = false;
      flagISC = false;
    }

    if (!flagAfecto || flagExonerado) {
      flagPrecioIncluyeIGV = false;
    }
    if (value == false && property == "arrFlagGratuito") {
      flagAfecto = row.flagAfecto;
      flagISC = row.flagISC;
      flagExonerado = row.flagExonerado;
    }
    /*********** Calculo precios unitarios ********/
    var divisorCalculoSubTotal = 1 + porcentajeIGV / 100;
    var precioUnitarioSinIGV = flagPrecioIncluyeIGV
      ? precioUnitario / divisorCalculoSubTotal
      : precioUnitario;

    /*********** Calculo por ISC ********/
    var importeISC = flagISC ? precioUnitarioSinIGV * (porcentajeISC / 100) : 0;
    var precioUnitarioISC = flagISC ? precioUnitarioSinIGV + importeISC : 0;
    var totalDetalle = flagISC
      ? cantidad * precioUnitarioISC
      : cantidad * precioUnitarioSinIGV;

    /*********** Calculo totales ********/
    var subTotal = totalDetalle;
    var igv = parseFloat(flagAfecto ? subTotal * (porcentajeIGV / 100) : 0);
    total = parseFloat(subTotal + igv);

    if (property === "arrTotal" && parseFloat(newValue) !== total) {
      flagISC = false;
      importeISC = 0;
      precioUnitarioISC = 0;
      flagChangeTotal = true;

      /*********** Calculo totales ********/
      total = parseFloat(value);
      porcentajeDescuento = 0;
      importeDescuento = 0;
      subTotal = parseFloat(
        flagAfecto ? total / (1 + porcentajeIGV / 100) : total
      );

      /*********** Calculo por ISC ********/
      totalDetalle = flagISC ? cantidad * precioUnitarioISC : subTotal;

      /*********** Calculo Cantidad ********/
      cantidad = parseFloat((subTotal / precioUnitarioSinIGV).toFixed(3));
      /*********** Calculo IGV ********/
      igv = flagAfecto ? subTotal * (porcentajeIGV / 100) : 0;
    }

    /*********** Calculo descuentos ********/
    if (importeDescuento > 0 || porcentajeDescuento > 0) {
      var calculoimporteDescuento = 0;
      if (flagPrecioIncluyeIGV) {
        calculoimporteDescuento = parseFloat(
          (total * (porcentajeDescuento / 100)).toFixed(2)
        );
      } else {
        calculoimporteDescuento = parseFloat(
          (totalDetalle * (porcentajeDescuento / 100)).toFixed(2)
        );
      }

      if (
        importeDescuento !== calculoimporteDescuento &&
        property === "arrImporteDescuento"
      )
        porcentajeDescuento = 0;
      else importeDescuento = calculoimporteDescuento;

      if (flagPrecioIncluyeIGV) {
        total = total - importeDescuento;

        if (flagAfecto) {
          subTotal = parseFloat((total / divisorCalculoSubTotal).toFixed(2));
          igv = total - subTotal;
          totalDetalle = subTotal;
        } else {
          subTotal = total;
          igv = 0;
          totalDetalle = subTotal;
        }
      } else {
        subTotal = subTotal - importeDescuento;

        if (flagAfecto) {
          var igv = parseFloat(
            (flagAfecto ? subTotal * (porcentajeIGV / 100) : 0).toFixed(2)
          );
          total = parseFloat((subTotal + igv).toFixed(2));
        } else {
          total = subTotal;
          subTotal = subTotal;
          igv = 0;
          totalDetalle = subTotal;
        }
      }
    }

    /*********** Calculo gratuito ********/
    if (flagGratuito) {
      porcentajeDescuento = 0;
      importeDescuento = 0;
      igv = 0;
      subTotal = 0;
      total = 0;
    }

    /*********** Actualizar Detalle de Productos ********/
    var detalleProductos = this.props.form.getFieldValue("detalleProductos");
    var detalleProductosFilter = detalleProductos.filter((m) => {
      return m.identifier !== row.identifier;
    });
    var dateVcto = row.flagVencimiento ? row.fechaVencimientoStr : null;

    var dataNueva = {
      identifier: row.identifier,
      numeroLote: this.props.form.getFieldValue(`arrNumeroLote[${row.identifier}]`),
      nombre: this.props.form.getFieldValue(`arrNombre[${row.identifier}]`),
      codigo: this.props.form.getFieldValue(`arrcodigo[${row.identifier}]`),
      idProducto: row.idProducto,
      idTipoProducto: row.idTipoProducto,
      flagAplicarSerie: row.flagAplicarSerie,
      listaDetalleSerie: row.listaDetalleSerie,
      detalleSeries: row.detalleSeries,
      precioPromedio: precioPromedio,
      porcentajeMargenComercial: porcentajeMargenComercial,
      cantidad,
      precioUnitarioSinIGV,
      precioUnitario,
      porcentajeDescuento,
      importeDescuento,
      flagAfecto,
      flagExonerado,
      flagISC,
      flagOtrosImpuesto: false, // OMITIDO POR EL MOMENTO
      flagGratuito,
      flagChangeTotal,
      total,
      subTotal,
      isItemLibre: row.isItemLibre == undefined ? false : row.isItemLibre,
      idUnidadMedida: idUnidadMedida,
      idImpuesto: selectedImpuesto?.id ?? 1,
      flagConversion: row.flagConversion,
      flagVencimiento: row.flagVencimiento,
      fechaVencimientoStr: dateVcto

    };
    detalleProductosFilter.splice(index, 0, dataNueva);

    /*********** Re-Calcular Suma SubTotal ********/

    var sumaTotalAfecto = this.fetchSumaTotalAfecto(
      row.identifier,
      codigo,
      total
    );
    var sumaTotalInafecto = this.fetchSumaTotalInafecto(
      row.identifier,
      codigo,
      total
    );

    var fetchSumaTotalExonerado = this.fetchSumaTotalExonerado(
      row.identifier,
      codigo,
      total
    );

    var fetchSumaTotalGratuito = this.fetchSumaTotalGratuito(
      row.identifier,
      codigo,
      total
    );

    var sumaTotalExportacion = this.fetchSumaTotalExportacion(
      row.identifier,
      codigo,
      total
    );
    /*********** Calculo suma detalle ********/
    var sumaImporteDescuento = this.fetchFieldValueSum(
      row.identifier,
      "arrImporteDescuento",
      importeDescuento
    );

    var sumaIsc = this.fetchFieldValueSum(
      row.identifier,
      "arrIsc",
      cantidad === 0 ? 0 : importeISC
    );
    var sumaTotal = parseFloat(
      this.fetchFieldValueSum(row.identifier, "arrTotal", total).toFixed(2)
    );
    var sumaSubTotal = parseFloat(
      (
        sumaTotalAfecto / divisorCalculoSubTotal +
        (sumaTotalInafecto + fetchSumaTotalExonerado + sumaTotalExportacion)
      ).toFixed(2)
    );
    sumaTotal = sumaTotal - fetchSumaTotalGratuito;
    var sumaIgv = (sumaTotal) - sumaSubTotal;
    var sumaTotalDetalle = sumaSubTotal;

    /*********** DECUENTOS GLOBALES ********/

    if (
      [FACTURA.ID, BOLETA_DE_VENTA.ID].includes(
        this.props.form.getFieldValue("idTipoComprobante")
      )
    ) {

      var flagDescuentoGlobal = this.props.form.getFieldValue(
        "flagDescuentoGlobal"
      );

      if (flagDescuentoGlobal) {
        var importeDescuentoGlobal = this.props.form.getFieldValue(
          "importeDescuentoGlobal"
        );
        var porcentajeDescuentoGlobal = this.props.form.getFieldValue(
          "porcentajeDescuentoGlobal"
        );
        if (
          isNaN(parseFloat(importeDescuentoGlobal)) ||
          importeDescuentoGlobal === ""
        ) {
          importeDescuentoGlobal = 0;
        }
        if (
          isNaN(parseFloat(porcentajeDescuentoGlobal)) ||
          porcentajeDescuentoGlobal === ""
        ) {
          porcentajeDescuentoGlobal = 0;
        }

        if (importeDescuentoGlobal > 0) {
          if (flagPrecioIncluyeIGV) {
            if (importeDescuentoGlobal > sumaTotal) {
              importeDescuentoGlobal = 0;
              porcentajeDescuentoGlobal = 0;
            }

            sumaTotal = sumaTotal - importeDescuentoGlobal;

            if (sumaIgv !== 0) {
              sumaSubTotal = parseFloat(
                (sumaTotal / divisorCalculoSubTotal).toFixed(2)
              );
              sumaIgv = sumaTotal - sumaSubTotal;
              sumaTotalDetalle = sumaSubTotal;
            } else {
              sumaSubTotal = sumaTotal;
              sumaIgv = 0;
              sumaTotalDetalle = sumaSubTotal;
            }
          } else {
            if (importeDescuentoGlobal > sumaSubTotal) {
              importeDescuentoGlobal = 0;
              porcentajeDescuentoGlobal = 0;
            }

            sumaSubTotal = sumaSubTotal - importeDescuentoGlobal;

            if (sumaIgv !== 0) {
              sumaIgv = parseFloat(
                (sumaIgv !== 0
                  ? sumaSubTotal * (porcentajeIGV / 100)
                  : 0
                ).toFixed(2)
              );
              sumaTotal = parseFloat((sumaSubTotal + sumaIgv).toFixed(2));
            } else {
              sumaTotal = sumaSubTotal;
              sumaSubTotal = sumaSubTotal;
              sumaIgv = 0;
              sumaTotalDetalle = sumaSubTotal;
            }
          }
        }
      }



    }

    //#region "Anticipo"
    var importeAnticipo = this.props.form.getFieldValue("totalAnticipo");

    if (importeAnticipo > 0) {
      if (flagPrecioIncluyeIGV) {

        sumaTotal = sumaTotal - importeAnticipo;

        if (sumaIgv !== 0) {
          sumaSubTotal = parseFloat(
            (sumaTotal / divisorCalculoSubTotal).toFixed(2)
          );
          sumaIgv = sumaTotal - sumaSubTotal;
          sumaTotalDetalle = sumaSubTotal;
        } else {
          sumaSubTotal = sumaTotal;
          sumaIgv = 0;
          sumaTotalDetalle = sumaSubTotal;
        }
      } else {

        sumaSubTotal = sumaSubTotal - importeAnticipo;

        if (sumaIgv !== 0) {
          sumaIgv = parseFloat(
            (sumaIgv !== 0
              ? sumaSubTotal * (porcentajeIGV / 100)
              : 0
            ).toFixed(2)
          );
          sumaTotal = parseFloat((sumaSubTotal + sumaIgv).toFixed(2));
        } else {
          sumaTotal = sumaSubTotal;
          sumaSubTotal = sumaSubTotal;
          sumaIgv = 0;
          sumaTotalDetalle = sumaSubTotal;
        }
      }
    }


    //#endregion

    /*********** Calculo de Totales 2 ********/

    /*********** Calculo Percepcion ********/
    var flagPercepcion = this.props.form.getFieldValue("flagPercepcion");
    var porcentajePercepcion = parseFloat(
      auth
        .user()
        .parametros.filter((m) => m.abreviatura === PORCENTAJE_PERCEPCION)[0]
        .valor
    );
    var importePercepcion = sumaTotal * (porcentajePercepcion / 100);
    var totalPercepcion = sumaTotal + importePercepcion;

    /*********** Calculo Detracion ********/
    var flagDetraccion = this.props.form.getFieldValue("flagDetraccion");
    var porcentajeDetraccion = this.props.form.getFieldValue("porcentajeDetraccion");

    var codigoMoneda = this.props.form.getFieldValue("codigoMoneda");
    var nroDecimal = codigoMoneda == 'PEN' ? 0 : 2;

    var importeDetraccion = sumaTotal * (porcentajeDetraccion / 100);
    importeDetraccion = parseFloat(importeDetraccion.toFixed(parseInt(nroDecimal)));
    var totalDetraccion = parseFloat(sumaTotal - importeDetraccion);


    /*********** Calculo Retencion ********/
    var flagRetencion = this.props.form.getFieldValue("flagRetencion");
    var porcentajeRetencion = this.props.form.getFieldValue("porcentajeRetencion");
    var importeRetencion = sumaTotal * (porcentajeRetencion / 100);
    var totalRetencion = sumaTotal - importeRetencion;


    this.props.form.setFieldsValue({
      sumaImporteDescuento: sumaImporteDescuento,
      sumaIsc: sumaIsc,
      sumaTotal: sumaTotal,
      sumaSubTotal: sumaSubTotal,
      sumaIgv: sumaIgv,
      sumaTotalDetalle: sumaTotalDetalle,

      sumaExonerada: fetchSumaTotalExonerado,
      sumaInafecta: sumaTotalInafecto,
      sumaGratuita: fetchSumaTotalGratuito,

      importeDescuentoGlobal: importeDescuentoGlobal,
      porcentajeDescuentoGlobal: porcentajeDescuentoGlobal,
      detalleProductos: detalleProductosFilter,
      [`arrFlagAfecto[${row.identifier}]`]: flagAfecto,
      [`arrFlagExonerado[${row.identifier}]`]: flagExonerado,
      [`arrFlagGratuito[${row.identifier}]`]: flagGratuito,
      [`arrFlagISC[${row.identifier}]`]: flagISC,
      [`arrIsc[${row.identifier}]`]: cantidad === 0 ? 0 : importeISC,
      [`arrPrecioUnitario[${row.identifier}]`]: precioUnitario.toFixed(precioVenta),
      [`arrValorUnitario[${row.identifier}]`]: precioUnitarioSinIGV.toFixed(precioVenta),
      [`arrCantidad[${row.identifier}]`]: cantidad.toFixed(cantidadVenta),
      [`arrTotalDetalle[${row.identifier}]`]: totalDetalle.toFixed(2),
      [`arrPorcentajeDescuento[${row.identifier}]`]: porcentajeDescuento.toFixed(2),
      [`arrImporteDescuento[${row.identifier}]`]: importeDescuento.toFixed(2),
      [`arrSubTotal[${row.identifier}]`]: subTotal.toFixed(2),
      [`arrIgv[${row.identifier}]`]: igv.toFixed(2),
      [`arrTotal[${row.identifier}]`]: total.toFixed(2),
      porcentajePercepcion: flagPercepcion ? porcentajePercepcion : 0,
      importePercepcion: flagPercepcion ? importePercepcion : 0,
      totalPercepcion: flagPercepcion ? totalPercepcion : 0,
      importeRetencion: flagRetencion ? importeRetencion : 0,
      totalRetencion: flagRetencion ? totalRetencion : 0,
      porcentajeDetraccion: flagDetraccion ? porcentajeDetraccion : 0,
      importeDetraccion: flagDetraccion ? importeDetraccion : 0,
      totalDetraccion: flagDetraccion ? totalDetraccion : 0,
    });

    // 2 factura 4 boleta
    if (this.props.formValues.idTipoComprobante == 2 || this.props.formValues.idTipoComprobante == 4) {
      setTimeout(() => { this.handleCalculateMetodoPago(sumaTotal) }, 500)

      if (auth.user().planCode != "PLA003") { // only prodcut 5 
        var montoRecibido = this.props.form.getFieldValue("montoRecibido");
        if (montoRecibido == "") {
          montoRecibido = 0;
        }
        montoRecibido = parseInt(montoRecibido);

        if (montoRecibido > 0) {
          if (montoRecibido >= sumaTotal) {
            this.props.form.setFieldsValue({
              montoVuelto: (montoRecibido - sumaTotal).toFixed(2),
              montoRecibido: montoRecibido,
            });

          } else {
            this.props.form.setFieldsValue({
              montoVuelto: 0,
              montoRecibido: 0,
            });
          }


        }
      }


    }
  };

  handleRemoverProducto = (row) => {

    /*********** PARAMETROS ********/
    var params = auth.user().parametros;
    var flagPrecioIncluyeIGV =
      params.filter(
        (m) => m.abreviatura === VENTA_PRECIO_UNITARIO_INCLUYE_IGV
      )[0].valor === "1"
        ? true
        : false;
    var otroImpuesto = this.props.form.getFieldValue("otroImpuesto");
    var porcentajeIGV = lst_tipo_impuesto.find(item => item.id === otroImpuesto?.key)?.value ?? 18;

    var divisorCalculoSubTotal = 1 + porcentajeIGV / 100;

    var detalleProductos = this.props.form.getFieldValue("detalleProductos");
    var detalleProductosFilter = detalleProductos.filter((m) => {
      return m.identifier !== row.identifier;
    });

    var sumaImporteDescuento = this.fetchFieldValueSum(
      row.identifier,
      "arrImporteDescuento",
      0
    );
    var importeAnticipo = this.props.form.getFieldValue("totalAnticipo") || 0;

    var sumaIsc = this.fetchFieldValueSum(row.identifier, "arrIsc", 0);
    var sumaTotal = this.fetchFieldValueSum(row.identifier, "arrTotal", 0);
    var sumaSubTotal = this.fetchFieldValueSum(row.identifier, "arrSubTotal", 0);
    sumaTotal = sumaTotal - importeAnticipo;
    if (importeAnticipo > 0) {
      sumaSubTotal = sumaTotal / 1.18;
    }
    var sumaIgv = sumaTotal - sumaSubTotal;
    var sumaTotalDetalle = sumaSubTotal;

    /*********** DECUENTOS GLOBALES ********/
    var flagDescuentoGlobal = this.props.form.getFieldValue(
      "flagDescuentoGlobal"
    );

    if (flagDescuentoGlobal && this.state.flagTributosIguales) {

      var importeDescuentoGlobal = this.props.form.getFieldValue(
        "importeDescuentoGlobal"
      );
      var porcentajeDescuentoGlobal = this.props.form.getFieldValue(
        "porcentajeDescuentoGlobal"
      );
      if (flagPrecioIncluyeIGV) {
        if (importeDescuentoGlobal > sumaTotal) {
          importeDescuentoGlobal = 0;
          porcentajeDescuentoGlobal = 0;
        }

        sumaTotal = sumaTotal - importeDescuentoGlobal;

        if (sumaIgv !== 0) {
          sumaSubTotal = parseFloat(
            (sumaTotal / divisorCalculoSubTotal).toFixed(2)
          );
          sumaIgv = sumaTotal - sumaSubTotal;
          sumaTotalDetalle = sumaSubTotal;
        } else {
          sumaSubTotal = sumaTotal;
          sumaIgv = 0;
          sumaTotalDetalle = sumaSubTotal;
        }
      } else {
        if (importeDescuentoGlobal > sumaSubTotal) {
          importeDescuentoGlobal = 0;
          porcentajeDescuentoGlobal = 0;
        }

        sumaSubTotal = sumaSubTotal - importeDescuentoGlobal;

        if (sumaIgv !== 0) {
          sumaIgv = parseFloat(
            (sumaIgv !== 0 ? sumaSubTotal * (porcentajeIGV / 100) : 0).toFixed(2)
          );
          sumaTotal = parseFloat((sumaSubTotal + sumaIgv).toFixed(2));
        } else {
          sumaTotal = sumaSubTotal;
          sumaSubTotal = sumaSubTotal;
          sumaIgv = 0;
          sumaTotalDetalle = sumaSubTotal;
        }
      }
    }

    /*********** Calculo de Totales 2 ********/

    /*********** Calculo Percepcion ********/
    var flagPercepcion = this.props.form.getFieldValue("flagPercepcion");
    var porcentajePercepcion = parseFloat(
      auth
        .user()
        .parametros.filter((m) => m.abreviatura === PORCENTAJE_PERCEPCION)[0]
        .valor
    );
    var importePercepcion = sumaTotal * (porcentajePercepcion / 100);
    var totalPercepcion = sumaTotal + importePercepcion;

    /*********** Calculo Detracion ********/
    var flagDetraccion = this.props.form.getFieldValue("flagDetraccion");
    var porcentajeDetraccion = this.props.form.getFieldValue(
      "porcentajeDetraccion"
    );
    var importeDetraccion = sumaTotal * (porcentajeDetraccion / 100);
    var totalDetraccion = sumaTotal - importeDetraccion;


    /*********** Calculo Retencion ********/
    var flagRetencion = this.props.form.getFieldValue("flagRetencion");
    var porcentajeRetencion = this.props.form.getFieldValue("porcentajeRetencion");
    var importeRetencion = sumaTotal * (porcentajeRetencion / 100);
    var totalRetencion = sumaTotal - importeRetencion;

    this.props.form.setFieldsValue({
      sumaImporteDescuento: sumaImporteDescuento,
      sumaIsc: sumaIsc,
      sumaTotal: sumaTotal,
      sumaSubTotal: sumaSubTotal,
      sumaIgv: sumaIgv,
      sumaTotalDetalle: sumaTotalDetalle,
      importeDescuentoGlobal: importeDescuentoGlobal,
      porcentajeDescuentoGlobal: porcentajeDescuentoGlobal,
      detalleProductos: detalleProductosFilter,
      porcentajePercepcion: flagPercepcion ? porcentajePercepcion : 0,
      importePercepcion: flagPercepcion ? importePercepcion : 0,
      totalPercepcion: flagPercepcion ? totalPercepcion : 0,
      porcentajeDetraccion: flagDetraccion ? porcentajeDetraccion : 0,
      importeDetraccion: flagDetraccion ? importeDetraccion : 0,
      totalDetraccion: flagDetraccion ? totalDetraccion : 0,
      importeRetencion: flagRetencion ? importeRetencion : 0,
      totalRetencion: flagRetencion ? totalRetencion : 0,
    });

    this.props.onRemoverProducto(row, this.props.form);

    // 2 factura 4 boleta
    if (this.props.formValues.idTipoComprobante == 2 || this.props.formValues.idTipoComprobante == 4) {
      setTimeout(() => { this.handleCalculateMetodoPago(sumaTotal) }, 500)

    }
  };

  fetchNewValue = (value, numberDecimals) => {
    if (numberDecimals === 2)
      return value === "" || isNaN(parseFloat(value).toFixed(2))
        ? 0
        : parseFloat(value);
    if (numberDecimals === 3)
      return value === "" || isNaN(parseFloat(value).toFixed(3))
        ? 0
        : parseFloat(value);
    if (numberDecimals === 5)
      return value === "" || isNaN(parseFloat(value).toFixed(5))
        ? 0
        : parseFloat(value);

    return 0;
  };

  fetchFieldValue = (identifier, property) => {
    var result = parseFloat(
      this.props.form.getFieldValue(`${property}[${identifier}]`)
    );
    return result;
  };

  fetchFieldValueSum = (identifier, property, paramValue) => {
    var suma = 0;
    var obj = Object.assign({}, this.props.form.getFieldValue(property));

    for (var [key, value] of Object.entries(obj)) {
      suma = suma + (key === identifier ? paramValue : parseFloat(value));
    }

    return suma;
  };


  fetchSumaTotalAfecto = (
    identifier,
    codex,
    total
  ) => {
    let suma = 0;

    const arrTotal = this.props.form.getFieldValue("arrTotal");
    const arrImpuesto = this.props.form.getFieldValue("arridImpuesto");

    for (const [key, value] of Object.entries(arrTotal)) {

      // 👉 obtenemos el id del impuesto
      const impuestoKey = arrImpuesto?.[key]?.key;

      const selectedImpuesto = this.props.formValues.tipoAfectacion.find(
        x => x.id === impuestoKey
      );

      const codigo = identifier === key ? codex : selectedImpuesto?.codigoSunat;

      // ✅ solo sumar si es 10 o 17
      var esGravado = ["10", "17"].includes(codigo);

      if (esGravado) {
        suma +=
          identifier === key
            ? Number(total.toFixed(2))
            : parseFloat(value);
      }
    }

    return suma;
  };


  fetchSumaTotalInafecto = (
    identifier,
    codex,
    total
  ) => {
    let suma = 0;

    const arrTotal = this.props.form.getFieldValue("arrTotal");
    const arrImpuesto = this.props.form.getFieldValue("arridImpuesto");

    for (const [key, value] of Object.entries(arrTotal)) {

      // 👉 obtenemos el id del impuesto
      const impuestoKey = arrImpuesto?.[key]?.key;

      const selectedImpuesto = this.props.formValues.tipoAfectacion.find(
        x => x.id === impuestoKey
      );

      const codigo = identifier === key ? codex : selectedImpuesto?.codigoSunat;

      // ✅ solo sumar si es 30
      const esInafecto = ["30"].includes(codigo);


      if (esInafecto) {
        suma +=
          identifier === key
            ? Number(total.toFixed(2))
            : parseFloat(value);
      }
    }

    return suma;
  };


  fetchSumaTotalExonerado = (
    identifier,
    codex,
    total
  ) => {
    let suma = 0;

    const arrTotal = this.props.form.getFieldValue("arrTotal");
    const arrImpuesto = this.props.form.getFieldValue("arridImpuesto");

    for (const [key, value] of Object.entries(arrTotal)) {

      // 👉 obtenemos el id del impuesto
      const impuestoKey = arrImpuesto?.[key]?.key;

      const selectedImpuesto = this.props.formValues.tipoAfectacion.find(
        x => x.id === impuestoKey
      );

      const codigo = identifier === key ? codex : selectedImpuesto?.codigoSunat;

      // ✅ solo sumar si es 20
      const esExonerado = ["20"].includes(codigo);

      if (esExonerado) {
        suma +=
          identifier === key
            ? Number(total.toFixed(2))
            : parseFloat(value);
      }
    }

    return suma;
  };


  fetchSumaTotalGratuito = (
    identifier,
    codex,
    total
  ) => {
    let suma = 0;

    const arrTotal = this.props.form.getFieldValue("arrTotal");
    const arrImpuesto = this.props.form.getFieldValue("arridImpuesto");

    for (const [key, value] of Object.entries(arrTotal)) {

      // 👉 obtenemos el id del impuesto
      const impuestoKey = arrImpuesto?.[key]?.key;

      const selectedImpuesto = this.props.formValues.tipoAfectacion.find(
        x => x.id === impuestoKey
      );

      const codigo = identifier === key ? codex : selectedImpuesto?.codigoSunat;

      // ✅ solo sumar si es 20
      const esGratuito = !["10", "20", "30", "40", "17"].includes(codigo);

      if (esGratuito) {
        suma +=
          identifier === key
            ? Number(total.toFixed(2))
            : parseFloat(value);
      }
    }

    return suma;
  };

  fetchSumaTotalExportacion = (
    identifier,
    codex,
    total
  ) => {
    let suma = 0;

    const arrTotal = this.props.form.getFieldValue("arrTotal");
    const arrImpuesto = this.props.form.getFieldValue("arridImpuesto");

    for (const [key, value] of Object.entries(arrTotal)) {

      // 👉 obtenemos el id del impuesto
      const impuestoKey = arrImpuesto?.[key]?.key;

      const selectedImpuesto = this.props.formValues.tipoAfectacion.find(
        x => x.id === impuestoKey
      );

      const codigo = identifier === key ? codex : selectedImpuesto?.codigoSunat;

      // ✅ solo sumar si es 40
      const esGratuito = ["40"].includes(codigo);

      if (esGratuito) {
        suma +=
          identifier === key
            ? Number(total.toFixed(2))
            : parseFloat(value);
      }
    }

    return suma;
  };

  handleChangeTotals = (property, value) => {

    if (value === "") {
      value = 0;
    }

    if (property === "montoRecibido" && auth.user().planCode != "PLA003") {

      var totalVuelto = 0;
      value = parseFloat(value);

      var total = this.fetchFieldValueSum("", "arrTotal", 0);
      if (total == 0) {

        this.props.form.setFieldsValue({
          montoVuelto: 0,
          montoRecibido: 0,
        });

        dialog.warning("Ingrese productos");
        return false;
      } else {

        if (value >= total) {
          totalVuelto = (value - total).toFixed(2);
        } else {
          dialog.warning("Monto recibido debe ser mayor o igual al monto total");
          return false;
        }

      }


      this.props.form.setFieldsValue({
        montoVuelto: totalVuelto,
        montoRecibido: value,
      });
    }

    if (property === "flagPercepcion" && value) {
      var porcentajePercepcion = parseFloat(
        auth
          .user()
          .parametros.filter((m) => m.abreviatura === PORCENTAJE_PERCEPCION)[0]
          .valor
      );
      var importePercepcion =
        this.fetchFieldValueSum("", "arrTotal", 0) *
        (porcentajePercepcion / 100);
      var totalPercepcion =
        this.fetchFieldValueSum("", "arrTotal", 0) + importePercepcion;

      this.props.form.setFieldsValue({
        porcentajePercepcion,
        importePercepcion,
        totalPercepcion,
        flagDetraccion: false,
        porcentajeDetraccion: 0,
        importeDetraccion: 0,
        totalDetraccion: 0,
        idDetraccion: undefined,
      });
    }

    if (property === "flagAnticipo") {

      this.props.form.setFieldsValue({ flagAnticipo: value });
      this.props.form.setFieldsValue({ flagPago: false });

      this.props.onAnticipo(value, this.props.form);
    }

    if (property === "flagRetencion" && value) {

      var porcentajeRetencion = this.props.form.getFieldValue("porcentajeRetencion") == 0 ? 3 : 3;
      var importeRetencion = this.fetchFieldValueSum("", "arrTotal", 0) * (porcentajeRetencion / 100);
      var totalRetencion = this.fetchFieldValueSum("", "arrTotal", 0) - importeRetencion;

      this.props.form.setFieldsValue({
        porcentajeRetencion,
        importeRetencion,
        totalRetencion,
        flagDetraccion: false,
        flagPercepcion: false,
        porcentajeDetraccion: 0,
        importeDetraccion: 0,
        totalDetraccion: 0,
        importePercepcion: 0,
        totalPercepcion: 0,
        idDetraccion: undefined,
      });
    }

    if (property === "flagDetraccion" && value) {
      this.props.form.setFieldsValue(
        {
          flagPercepcion: false,
          flagRetencion: false,
          flagPago: false,
          idCaja: { key: undefined }
        },
        () => {
          this.props.form.validateFields(["idDetraccion"], { force: true });
        }
      );
    }

    if (property === "idDetraccion") {
      var importeDetraccion = 0;
      var codigoMoneda = this.props.form.getFieldValue("codigoMoneda");
      var nroDecimal = codigoMoneda == 'PEN' ? 0 : 2;

      var importeDetraccion = parseFloat((this.fetchFieldValueSum("", "arrTotal", 0) * (value / 100)).toFixed(parseInt(nroDecimal)));
      var totalDetraccion = parseFloat((this.fetchFieldValueSum("", "arrTotal", 0) - importeDetraccion).toFixed(2));

      this.props.form.setFieldsValue({
        flagPercepcion: false,
        porcentajePercepcion: 0,
        importePercepcion: 0,
        totalPercepcion: 0,
        porcentajeDetraccion: value,
        importeDetraccion,
        totalDetraccion,

      });
    }

    if (
      [FACTURA.ID, BOLETA_DE_VENTA.ID].includes(
        this.props.form.getFieldValue("idTipoComprobante")
      ) &&
      (property === "porcentajeDescuentoGlobal" ||
        property === "importeDescuentoGlobal" ||
        property === "flagDescuentoGlobal")
    ) {


      var detalleProductos = this.props.form.getFieldValue("detalleProductos");
      var checkDescuento = false;
      var totalMetodoPago = parseFloat(detalleProductos.filter(e => e.flagAfecto).reduce((a, b) => a + (b["total"] || 0), 0));

      if (property === "flagDescuentoGlobal") {
        if (detalleProductos.length > 0 && value) {

          detalleProductos.forEach(element => {

            if (element.flagAfecto) {
              checkDescuento = true;
              return false;
            }


          });

          if (checkDescuento) {
            this.setState({
              flagTributosIguales: value,
            })

            return false;
          } else {
            this.setState({
              flagTributosIguales: false,
            })
            dialog.error('Para aplicar Descuento Global por lo menos un producto debe estar afecto a IGV');

          }
        } else {
          this.setState({
            flagTributosIguales: false,
          })

        }
        if (!value) {
          this.props.form.setFieldsValue({
            importeDescuentoGlobal: 0,
            porcentajeDescuentoGlobal: 0
          });
        }
      }




      /********  PARAMETROS ********/
      var params = auth.user().parametros;
      var flagPrecioIncluyeIGV =
        params.filter(
          (m) => m.abreviatura === VENTA_PRECIO_UNITARIO_INCLUYE_IGV
        )[0].valor === "1"
          ? true
          : false;
      var otroImpuesto = this.props.form.getFieldValue("otroImpuesto");
      var porcentajeIGV = lst_tipo_impuesto.find(item => item.id === otroImpuesto?.key)?.value ?? 18;

      /******** VARIABLES ********/
      var totalDetalle = 0;
      var total = this.fetchFieldValueSum("", "arrTotal", 0);
      var subTotal = this.fetchFieldValueSum("", "arrSubTotal", 0);
      var calculoimporteDescuentoGlobal = 0;
      var importeDescuentoGlobal = parseFloat(
        this.props.form.getFieldValue("importeDescuentoGlobal")
      );
      var porcentajeDescuentoGlobal = parseFloat(
        this.props.form.getFieldValue("porcentajeDescuentoGlobal")
      );
      var igv = parseFloat(this.props.form.getFieldValue("sumaIgv"));
      var divisorCalculoSubTotal = 1 + porcentajeIGV / 100;

      if (property === "porcentajeDescuentoGlobal") {
        porcentajeDescuentoGlobal = parseFloat(value);
      } else if (property === "importeDescuentoGlobal") {
        importeDescuentoGlobal = parseFloat(value);
      } else if (property === "flagDescuentoGlobal") {
        importeDescuentoGlobal = parseFloat(0);
        porcentajeDescuentoGlobal = parseFloat(0);
      }

      /******** CALCULOS DESCUENTO ********/
      if (flagPrecioIncluyeIGV) {
        calculoimporteDescuentoGlobal = parseFloat(
          (total * (porcentajeDescuentoGlobal / 100)).toFixed(2)
        );
      } else {
        calculoimporteDescuentoGlobal = parseFloat(
          (total * (porcentajeDescuentoGlobal / 100)).toFixed(2)
        );
      }

      if (
        porcentajeDescuentoGlobal !== 0 &&
        property === "porcentajeDescuentoGlobal"
      )
        importeDescuentoGlobal = calculoimporteDescuentoGlobal;

      if (importeDescuentoGlobal !== 0 && property === "importeDescuentoGlobal")
        porcentajeDescuentoGlobal = 0;

      /******** CALCULOS TOTALES ********/

      if (flagPrecioIncluyeIGV) {
        if (importeDescuentoGlobal > total || importeDescuentoGlobal === 0) {
          importeDescuentoGlobal = 0.0;
          porcentajeDescuentoGlobal = 0.0;
        }

        total = total - importeDescuentoGlobal;

        if (igv !== 0) {
          subTotal = parseFloat((total / divisorCalculoSubTotal).toFixed(2));
          igv = total - subTotal;
          totalDetalle = subTotal;
        } else {
          subTotal = total;
          igv = 0;
          totalDetalle = subTotal;
        }
      } else {
        if (importeDescuentoGlobal > subTotal || importeDescuentoGlobal === 0) {
          importeDescuentoGlobal = 0.0;
          porcentajeDescuentoGlobal = 0.0;
        }
        subTotal = subTotal - importeDescuentoGlobal;

        if (igv !== 0) {
          igv = parseFloat(
            (igv !== 0 ? subTotal * (porcentajeIGV / 100) : 0).toFixed(2)
          );
          total = parseFloat((subTotal + igv).toFixed(2));
        } else {
          total = subTotal;
          subTotal = subTotal;
          igv = 0;
          totalDetalle = subTotal;
        }
      }


      /******** SETEAR CALCULOS TOTALES ********/
      this.props.form.setFieldsValue({
        flagDescuentoGlobal: value,
        sumaTotal: total,
        sumaIgv: igv,
        sumaSubTotal: subTotal,
        sumaTotalDetalle: totalDetalle,
        importeDescuentoGlobal: parseFloat(importeDescuentoGlobal.toFixed(2)),
        porcentajeDescuentoGlobal: parseFloat(
          porcentajeDescuentoGlobal.toFixed(2)
        ),
      });
    }

    this.props.CalculateDescuento(importeDescuentoGlobal, porcentajeDescuentoGlobal, this.props.form);

  };

  fetchReferencias = (values) => {
    var result = [];
    // 
    var flagReferencia = this.props.form.getFieldValue("flagReferencia");
    if (!flagReferencia) {
      this.props.formValues.listaComprobanteReferencia.forEach((item) => {
        result.push({
          idTipoComprobante: item.idTipoComprobante,
          flagInterno: item.flagInterno,
          idReferenciaOrigen: item.idReferenciaOrigen,
          idReferencia: item.idReferencia,
          serie: item.serie,
          documento: item.documento,
        });
      });
      return result;
    }

    if (
      values.arrTipoComprobante === undefined ||
      values.arrSerie === undefined ||
      values.arrDocumento === undefined ||
      values.arrIdReferencia === undefined ||
      values.arrIdReferenciaOrigen === undefined ||
      values.arrFlagInterno === undefined
    )
      return result;

    var keys = [];
    var obj = Object.assign({}, values.arrTipoComprobante);

    for (var [key] of Object.entries(obj)) {
      keys.push(key);
    }
    keys.forEach((key) => {
      result.push({
        idTipoComprobante: values.arrTipoComprobante[key].key,
        serie: values.arrSerie[key],
        documento: values.arrDocumento[key],
        idReferencia: values.arrIdReferencia[key],
        idReferenciaOrigen: values.arrIdReferenciaOrigen[key],
        flagInterno: values.arrFlagInterno[key],
      });
    });

    return result;
  };

  fetchCuotas = (values) => {
    var result = [];

    if (values.idTipoComprobante != BOLETA_DE_VENTA.ID) {
      var flagCuota = this.props.form.getFieldValue("flagCuota");
      if (!flagCuota) {
        this.props.formValues.listaComprobanteCuota.forEach((item) => {
          result.push({
            fechaVencimientoStr: item.fechaVencimiento,
            montoCuota: item.montoCuota,
          });
        });
        return result;
      }

      if (
        values.arrFechaVencimiento === undefined ||
        values.arrMontoCuota === undefined
      )
        return result;

      var keys = [];
      var obj = Object.assign({}, values.arrFechaVencimiento);

      for (var [key] of Object.entries(obj)) {
        keys.push(key);
      }
      keys.forEach((key) => {
        result.push({
          fechaVencimientoStr:
            values.arrFechaVencimiento[key].format("DD/MM/YYYY"),
          correlativo: parseFloat(values.arrCorrelativo[key]),
          montoCuota: parseFloat(values.arrMontoCuota[key]),
        });
      });
    }

    return result;
  };

  //#region  [MEDIO DE PAGO] 

  fetchMetodoPago = (values) => {
    var result = [];
    var flagPago = this.props.form.getFieldValue("flagPago");

    if ([FACTURA.ID].includes(values.idTipoComprobante) && values.idFormaPago.key === CONTADO) {
      var flagMetodoPago = this.props.form.getFieldValue("flagMetodoPago");
      if (!flagMetodoPago) {
        this.props.formValues.listaComprobanteMetodoPago.forEach((item) => {
          result.push({
            fechaPagoStr: item.fechaPago,
            idMetodoPago: item.idMetodoPago,
            idCuenta: item.idCuenta,
            referencia: item.referencia,
            montoPago: item.montoPago,
          });
        });
        return result;
      }

      if (
        values.arrFechaPago === undefined ||
        values.arrMontoPago === undefined
      )
        return result;

      var keys = [];
      var obj = Object.assign({}, values.arrFechaPago);

      for (var [key] of Object.entries(obj)) {
        keys.push(key);
      }
      keys.forEach((key) => {
        var cuenta = values.arrIdCuenta[key] === undefined ? 0 : values.arrIdCuenta[key].key;
        var banco = cuenta == 0 ? 0 : this.props.formValues.cuentas.filter(e => e.id = cuenta);

        result.push({
          fechaPagoStr: values.arrFechaPago[key].format("DD/MM/YYYY"),
          idMetodoPago: values.arrIdTipoMetodoPago[key].key,
          idCuenta: values.arrIdCuenta[key] === undefined ? 0 : values.arrIdCuenta[key].key,
          referencia: values.arrReferenciaPago[key],
          montoPago: parseFloat(values.arrMontoPago[key]),
          idCajaApertura: flagPago ? values.idCaja.key : 0,
          idMoneda: values.idMoneda.key,
          idBanco: banco == 0 ? 0 : banco[0].idBanco
        });
      });
    } else {

      if ((values.idTipoComprobante === BOLETA_DE_VENTA.ID) && this.props.formValues.idFormaPago == CONTADO) { //SI
        if (
          values.arrFechaPago === undefined ||
          values.arrMontoPago === undefined
        )
          return result;

        var keys = [];
        var obj = Object.assign({}, values.arrFechaPago);

        for (var [key] of Object.entries(obj)) {
          keys.push(key);
        }
        keys.forEach((key) => {
          var cuenta = values.arrIdCuenta[key] === undefined ? 0 : values.arrIdCuenta[key].key;
          var banco = cuenta == 0 ? 0 : this.props.formValues.cuentas.filter(e => e.id = cuenta);

          result.push({
            fechaPagoStr: values.arrFechaPago[key].format("DD/MM/YYYY"),
            idMetodoPago: values.arrIdTipoMetodoPago[key].key,
            idCuenta: values.arrIdCuenta[key] === undefined ? 0 : values.arrIdCuenta[key].key,
            referencia: values.arrReferenciaPago[key],
            montoPago: parseFloat(values.arrMontoPago[key]),
            idCajaApertura: flagPago ? values.idCaja.key : 0,
            idMoneda: values.idMoneda.key,
            idBanco: banco == 0 ? 0 : banco[0].idBanco
          });
        });
      }
    }

    return result;
  };

  fetchMetodoPagoBoleta = (values) => {
    var result = [];

    if (values.idTipoComprobante === BOLETA_DE_VENTA.ID && values.idFormaPago.key === undefined && values.idPendiente.key == 2) {
      var flagMetodoPago = this.props.form.getFieldValue("flagMetodoPago");
      if (!flagMetodoPago) {
        this.props.formValues.listaComprobanteMetodoPago.forEach((item) => {
          result.push({
            fechaPagoStr: item.fechaPago,
            idMetodoPago: item.idMetodoPago,
            idCuenta: item.idCuenta,
            referencia: item.referencia,
            montoPago: item.montoPago,
          });
        });
        return result;
      }

      if (
        values.arrFechaPago === undefined ||
        values.arrMontoPago === undefined
      )
        return result;

      var keys = [];
      var obj = Object.assign({}, values.arrFechaPago);

      for (var [key] of Object.entries(obj)) {
        keys.push(key);
      }
      keys.forEach((key) => {
        result.push({
          fechaPagoStr:
            values.arrFechaPago[key].format("DD/MM/YYYY"),
          idMetodoPago: values.arrIdTipoMetodoPago[key].key,
          idCuenta: values.arrIdCuenta[key] === undefined ? 0 : values.arrIdCuenta[key].key,
          referencia: values.arrReferenciaPago[key],
          montoPago: parseFloat(values.arrMontoPago[key]),
        });
      });
    }

    return result;
  };


  //#endregion  [END MEDIO DE PAGO]


  handleCancel = () => {
    this.props.onClose();
    this.props.form.resetFields();
  };

  handleValidateStock = (products, stockProducts) => {

    var elements = [];
    const productGroup = global.groupBy(products, (item) => [
      item.idProducto,
      item.numeroLote,
    ]);

    productGroup.forEach((item) => {
      /**** BUSCAR STOCK POR PRODUCTO Y LOTE ***/
      var stock = stockProducts.filter(
        (m) =>
          m.idProducto === item[0].idProducto &&
          m.numeroLote === item[0].numeroLote
      )[0].stock;

      /**** FILTRAR PRODUCTOS POR ID Y LOTE ***/
      var filteredProducts = products.filter(
        (m) =>
          m.idProducto === item[0].idProducto &&
          m.numeroLote === item[0].numeroLote
      );

      /**** SUMAR CANTIDAD DE PRODUCTOS POR ID Y LOTE ***/
      var total = filteredProducts.reduce(
        (a, b) => a + (b["cantidad"] || 0),
        0
      );

      /**** OBTENER NOMBRE DE PRODUCTOS AFECTADOS POR STOCK ***/
      var productNames = Array.from(
        new Set(filteredProducts.map((m) => m.nombre))
      );

      if (total > stock) {
        elements.push(
          <li>
            Stock no disponible para los productos:{" "}
            <b>{productNames.join(", ")}</b>
          </li>
        );
      }
    });

    return elements;
  };

  handleValidatDetalleAfecto = (products) => {
    var elements1 = [];
    var elements2 = [];
    products.forEach((item) => {
      if (item.flagAfecto) {
        elements1.push(item);
      } else {
        if (item.flagGratuito || item.flagISC) {
          elements1.push(item);
        } else {
          elements2.push(item);
        }
      }
    });

    if (
      elements1.length === products.length ||
      elements2.length === products.length
    )
      return true;
    else return false;
  };

  handleOk = (e) => {
    e.preventDefault();

    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const porcentajeIGV = lst_tipo_impuesto.find(item => item.id === values.otroImpuesto?.key)?.value ?? 18;

        const data = {
          id: values.id,
          idMovimiento: values.idMovimiento,
          idTipoComprobante: values.idTipoComprobante,
          idCliente: values.idCliente.key,
          idEstablecimientoCliente:
            values.idEstablecimientoCliente === undefined
              ? 0
              : values.idEstablecimientoCliente.key,
          idVendedor:
            values.idVendedor === undefined ? 0 : values.idVendedor.key,
          idAlmacen: values.idAlmacen.key,
          idMoneda: values.idMoneda.key,
          idCaja: 0,
          idFormaPago:
            values.idFormaPago === undefined ? 0 : values.idFormaPago.key,
          idListaPrecio: values.idListaPrecio.key,
          idEstablecimiento: values.idEstablecimiento.key,
          idDetraccion:
            values.idDetraccion === undefined ? 0 : values.idDetraccion.key,
          totalDetraccion:
            values.idDetraccion === undefined ? 0 : values.totalDetraccion,
          idUsuarioRegistro: values.idUsuarioRegistro,
          serie: values.serie.toUpperCase(),
          documento: values.documento,
          fechaStr: values.fechaStr.format("DD/MM/YYYY"),
          fechaVencimientoStr: values.fechaVencimientoStr.format("DD/MM/YYYY"),
          diasVencimiento: parseInt(values.diasVencimiento),
          numeroPlaca: values.numeroPlaca == undefined ? null : values.numeroPlaca,
          tipoCambio: parseFloat(values.tipoCambio),
          observacion: values.observacion,
          idProyecto: values.idProyecto.key == null ? 0 : values.idProyecto.key,

          flagAmazoniaServicio: values.flagAmazonia ? values.flagAmazoniaServicio : false,
          flagAmazoniaBien: values.flagAmazonia ? values.flagAmazoniaBien : false,
          nroOrden: values.nroOrden == undefined ? null : values.nroOrden,
          flagClaim: this.props.formValues.flagClaim == undefined ? false : this.props.formValues.flagClaim,


          condicionPago: values.condicionPago === undefined ? "" : values.condicionPago,
          montoRecibido: values.montoRecibido == undefined ? 0 : parseFloat(values.montoRecibido),
          montoVuelto: values.montoVuelto == undefined ? 0 : parseFloat(values.montoVuelto),
          flagDescuentoGlobal: values.importeDescuentoGlobal > 0 ? true : false,
          flagExportacion: values.flagExportacion,
          flagPercepcion: values.flagPercepcion,
          flagDetraccion: values.flagDetraccion,
          flagRetencion: values.flagRetencion,
          flagPago: values.flagPago == undefined ? false : values.flagPago,
          flagImpresion: values.flagImpresion,

          idFenologica: values.idFenologica === undefined ? 0 : values.idFenologica.key,
          idCultivo: values.idCultivo === undefined ? 0 : values.idCultivo.key,
          idMedioPago: values.idMedioPago === undefined ? 0 : values.idMedioPago.key,

          giroNegocio: values.giroNegocio == undefined ? null : values.giroNegocio,
          porcentajeRetencion: values.porcentajeRetencion,
          importeRetencion: values.importeRetencion == undefined ? 0 : values.importeRetencion,
          totalRetencion: values.totalRetencion == undefined ? 0 : values.totalRetencion,
          flagEditDireccionCliente: values.flagEditDireccionCliente,
          direccionCliente: values.direccionCliente,
          idEstablecimientoClienteEdit: values.idEstablecimientoClienteEdit == undefined ? 0 : values.idEstablecimientoClienteEdit,
          flagGrifo: values.flagGrifo,
          porcentajeIGV: porcentajeIGV,
          flagAnticipo: values.flagAnticipo,
          flagRegularizacion: values.flagRegularizacion,
          idPendiente: values.idPendiente === undefined ? 2 : values.idPendiente.key, // 2 cancelado (NC)
          total: values.sumaTotal,
          encargado: values.encargado === undefined ? "" : values.encargado,
          idVehiculo: values.idVehiculo === undefined ? 0 : values.idVehiculo.key == undefined ? 0 : values.idVehiculo.key,
          montoAnticipo: values.totalAnticipo,
          importeDescuentoGlobal: parseFloat(
            values.importeDescuentoGlobal ?? 0
          ),
          porcentajeDescuentoGlobal: parseFloat(
            values.porcentajeDescuentoGlobal ?? 0
          ),
          flagContingencia: values.flagContingencia,
          listaComprobanteDetalle: values.detalleProductos,
          listaComprobanteReferencia: this.fetchReferencias(values),
          listaComprobanteCuota: this.fetchCuotas(values),
          listaComprobanteMetodoPago: this.fetchMetodoPago(values)
        };

        const validarStock =
          auth
            .user()
            .parametros.filter((m) => m.abreviatura === VALIDAR_STOCK)[0]
            .valor === "1"
            ? true
            : false;
        if (values.idTipoComprobante == 4)
          data.idFormaPago = 1; //solo boleta contado

        if (values.idFormaPago == CREDITO)
          data.listaComprobanteMetodoPago = [];

        const validFormLogic = this.validateFormLogic(data, values);
        if (!validFormLogic) {
          return;
        }

        this.props.onSave(data, this.props.form);
      }
    });
  };

  validateFormLogic = (data, values) => {

    if (data.listaComprobanteDetalle.length === 0) {
      dialog.warning("Por favor agregue por lo menos 1 producto.");
      return false;
    }

    if (data.listaComprobanteDetalle.filter(m => { return m.flagAplicarSerie === true; }).length > 0) {
      data.listaComprobanteDetalle.forEach(row => {
        if (row.listaDetalleSerie.length === 0 && row.flagAplicarSerie) {
          message.warning("Por favor agregue las series para el producto " + row.nombre);
          return false;
        }
      });
    }

    if (data.idFormaPago === CREDITO && data.listaComprobanteCuota.length === 0) {
      dialog.warning("Por favor agregue las cuotas para el comprobante a CRÉDITO.");
      return false;
    }

    if (data.idFormaPago === CREDITO) {
      const miArray = data.listaComprobanteCuota;

      if (!this.validate_fechaMayorQue(data.fechaStr, data.fechaVencimientoStr)) {
        dialog.warning("La fecha de vencimiento debe ser mayor que la fecha de emision");
        return false;
      }

      var latest = data.listaComprobanteCuota[data.listaComprobanteCuota.length - 1].fechaVencimientoStr;
      if (data.fechaVencimientoStr != latest) {
        dialog.warning("La ultima cuota debe tener la fecha igual que la fecha de vencimiento del documento");
        return false;
      }

      var firstItem = miArray[0];
      if (!this.validate_fechaMayorQue(data.fechaStr, firstItem.fechaVencimientoStr)) {
        dialog.warning("La primera cuota debe ser mayor que la fecha de emisión del comprobante");
        return false;
      }
      for (let i = 0; i < miArray.length - 1; i++) {
        var reg0 = miArray[i];
        var reg1 = miArray[i + 1];
        var date1 = reg0.fechaVencimientoStr;
        var date2 = reg1.fechaVencimientoStr;

        if (!this.validate_fechaMayorQue(date1, date2)) {
          dialog.warning('* la fecha de la cuota nro ' + reg1.correlativo + ' debe ser mayor que la cuota ' + (i + 1) + '\n');

          return false;
        }
      }
    }

    if ([FACTURA.ID, BOLETA_DE_VENTA.ID].includes(values.idTipoComprobante)) {

      if (values.flagAmazonia) {
        if (!values.flagAmazoniaServicio && !values.flagAmazoniaBien) {
          dialog.warning("Debe seleccionar bienes o servicios prestados en la selva");
          return false;
        }

        if (data.listaComprobanteDetalle.filter((m) => !m.flagExonerado).length > 0) {
          dialog.warning("La leyenda de Bienes y Servicios Región Selva solo se permite para IGV exonerados");
          return false;
        }
      }
    }


    var totalMetodoPago = parseFloat(data.listaComprobanteMetodoPago.reduce((a, b) => a + (b["montoPago"] || 0), 0));

    if (data.flagPago) {

      if (data.flagDetraccion) {
        dialog.warning("no puede realizar el pago ya que el comprobante esta con detracción");
        return false;
      }

      if (data.listaComprobanteMetodoPago.length === 0) {
        dialog.warning("Por favor agregue metodo de pago.");
        return;
      }

      if (data.total != totalMetodoPago) {
        dialog.warning("el monto de pago debe ser igual al monto total del documento");
        return;
      }

    }

    let esValido = true;
    data.listaComprobanteDetalle.forEach(element => {
      // Validar si el descuento deja el subtotal en 0 o menor a 0
      if (element.importeDescuento > 0) {
        const totalConDescuento = element.subTotal;
        if (totalConDescuento <= 0) {
          dialog.warning(`El item "${element.nombre || ''}" tiene un descuento del 100%. No se permite que el total sea 0 o menor.`);
          esValido = false;
        }
      }

    });
    if (!esValido) return false;

    //VALIDACIONES FORMA PAGO CONTADO
    /*     if ( (values.idTipoComprobante === BOLETA_DE_VENTA.ID ||
          values.idTipoComprobante === FACTURA.ID) &&
          data.idFormaPago === CONTADO
        ) {
          var totalMetodoPago = parseFloat( data.listaComprobanteMetodoPago.reduce((a, b) => a + (b["montoPago"] || 0), 0));
    
           if ( data.listaComprobanteMetodoPago.length === 0  && !data.flagDetraccion && data.idPendiente==2) {
            dialog.warning(
              "Por favor agregue el método de pago."
            );
            return false;
          }
     
          if (totalMetodoPago !== parseFloat(data.totalDetraccion.toFixed(2)) && data.flagDetraccion && data.idPendiente==2) {
            dialog.warning(
              "El monto total del método de pago, debe ser igual al total detracción."
            );
            return false;
          }else{
    
            if(data.flagDetraccion!=true){
              
              if (totalMetodoPago.toFixed(2) != parseFloat(data.total) && data.idPendiente==2) {
                dialog.warning(
                  "El monto total del método de pago, debe ser igual al total del comprobante."
                );
                return false;
              }
            }
        
          }
    
       
    
        } */

    /*     if ( (values.idTipoComprobante === BOLETA_DE_VENTA.ID) &&
          data.idFormaPago === undefined
        ) {
          var totalMetodoPago = parseFloat(
            data.listaComprobanteMetodoPago.reduce((a, b) => a + (b["montoPago"] || 0), 0)
          );
    
          
          if ( data.listaComprobanteMetodoPago.length === 0  && data.flagDetraccion==undefined && data.idPendiente== 2) {
            dialog.warning(
              "Por favor agregue el método de pago."
            );
            return false;
          }
    
          if (totalMetodoPago !== parseFloat(data.total) && !data.flagDetraccion && data.idPendiente==2) {
            dialog.warning(
              "El monto total del método de pago, debe ser igual al total del comprobante."
            );
            return false;
          }
    
        } */

    var totalCuotas = parseFloat(data.listaComprobanteCuota.reduce((a, b) => a + (b["montoCuota"] || 0), 0)).toFixed(2);

    if (data.idFormaPago === CREDITO) {
      if (totalCuotas != parseFloat(data.total).toFixed(2) && !data.flagDetraccion && !data.flagRetencion) {
        dialog.warning(
          "El monto total de cuotas, debe ser igual al total del comprobante."
        );
        return false;
      }

      if (totalCuotas != parseFloat(data.totalDetraccion.toFixed(2)) && data.flagDetraccion) {
        dialog.warning("El monto total de cuotas, debe ser igual al Importe Neto a Pagar.");

        return false;
      }

      if (totalCuotas != parseFloat(data.totalRetencion.toFixed(2)) && data.flagRetencion) {
        dialog.warning("El monto total de cuotas, debe ser igual al total Retencion.");
        return false;
      }
    }


    if (data.listaComprobanteDetalle.some(m => m.idImpuesto == 16) &&
      !data.listaComprobanteDetalle.every(m => m.idImpuesto == 16)
    ) {
      dialog.warning("Los comprobantes con casos de Exportación no están afectos al IGV / Ni exonerados.");
      return false;
    }

    const todosExportacion = data.listaComprobanteDetalle.every((m) => m.idImpuesto == 16);

    if (
      values.clientes[0].idTipoDocumento === 1 &&
      values.idTipoComprobante === 2 &&
      !todosExportacion
    ) {
      dialog.warning(
        "Los clientes con tipo de documentos OTROS, solo pueden generar FACTURAS con el tipo de operación EXPORTACIÓN."
      );
      return false;
    }
    return true;
  };

  fetchParameters = () => {
    var parameters = {};
    this.props.formValue.parameters.forEach((item) => {
      parameters[item.key] = item.value;
    });
    return parameters;
  };

  displaySizeObservacion = () => {
    var result = "";

    if (this.props.formValues.flagEmpresaGrifo) {
    } else result = "col-md-9 form-group";

    return result;
  };


  validate_fechaMayorQue(fechaInicial, fechaFinal) {
    var valuesStart = fechaInicial.split("/");
    var valuesEnd = fechaFinal.split("/");

    // Verificamos que la fecha no sea posterior a la actual
    var dateStart = new Date(valuesStart[2], (valuesStart[1] - 1), valuesStart[0]);
    var dateEnd = new Date(valuesEnd[2], (valuesEnd[1] - 1), valuesEnd[0]);
    if (dateStart >= dateEnd) {
      return 0;
    }
    return 1;
  }

  handleCalculateMetodoPago = (sumaTotal) => {

    this.props.onCalculateMetodoPago(sumaTotal, this.props.form);
  }


  render() {

    var flagContingencia = this.props.configuraciones.filter((m) => m.abreviatura === GENERAR_CNTINGENCIA).length >= 1 ? true : false;
    var flagFecha = this.props.configuraciones.filter((m) => m.abreviatura === EDITAR_FECHA).length >= 1 ? true : false;
    const seriePorProducto = auth.user().parametros.filter(m => m.abreviatura === SERIE_POR_PRODUCTO)[0].valor === "1" ? true : false;
    const { getFieldDecorator, setFieldsValue, getFieldValue } =
      this.props.form;

    getFieldDecorator("id", { initialValue: this.props.formValues.id });
    getFieldDecorator("idMovimiento", { initialValue: this.props.formValues.idMovimiento });

    getFieldDecorator("clientes", {
      initialValue: this.props.formValues.clientes.filter((m) => {
        return m.id === this.props.formValues.idCliente;
      }),
    });
    getFieldDecorator("idTipoComprobante", {
      initialValue: this.props.formValues.idTipoComprobante,
    });
    getFieldDecorator("flagGrifo", {
      initialValue: this.props.formValues.flagGrifo,
    });
    getFieldDecorator("idUsuarioRegistro", {
      initialValue: this.props.formValues.idUsuarioRegistro,
    });
    getFieldDecorator("sumaTotalDetalle", {
      initialValue: this.props.formValues.sumaTotalDetalle,
    });
    getFieldDecorator("totalAnticipo", {
      initialValue: this.props.formValues.totalAnticipo,
    });
    getFieldDecorator("sumaImporteDescuento", {
      initialValue: this.props.formValues.sumaImporteDescuento,
    });
    getFieldDecorator("sumaSubTotal", {
      initialValue: this.props.formValues.sumaSubTotal,
    });
    getFieldDecorator("sumaIgv", {
      initialValue: this.props.formValues.sumaIgv,
    });
    getFieldDecorator("sumaIsc", {
      initialValue: this.props.formValues.sumaIsc,
    });

    getFieldDecorator("sumaExonerada", {
      initialValue: this.props.formValues.sumaExonerada,
    });
    getFieldDecorator("sumaInafecta", {
      initialValue: this.props.formValues.sumaInafecta,
    });
    getFieldDecorator("sumaGratuita", {
      initialValue: this.props.formValues.sumaGratuita,
    });

    getFieldDecorator("sumaTotal", {
      initialValue: this.props.formValues.sumaTotal,
    });
    getFieldDecorator("detalleProductos", {
      initialValue: this.props.formValues.detalleProductos,
    });

    getFieldDecorator("porcentajeDetraccion", {
      initialValue: this.props.formValues.porcentajeDetraccion,
    });
    getFieldDecorator("importeDetraccion", {
      initialValue: this.props.formValues.importeDetraccion,
    });
    getFieldDecorator("totalDetraccion", {
      initialValue: this.props.formValues.totalDetraccion,
    });

    getFieldDecorator("importeRetencion", {
      initialValue: this.props.formValues.importeRetencion,
    });

    getFieldDecorator("totalRetencion", {
      initialValue: this.props.formValues.totalRetencion,
    });

    getFieldDecorator("porcentajeRetencion", {
      initialValue: this.props.formValues.porcentajeRetencion,
    });

    getFieldDecorator("porcentajePercepcion", {
      initialValue: this.props.formValues.porcentajePercepcion,
    });
    getFieldDecorator("importePercepcion", {
      initialValue: this.props.formValues.importePercepcion,
    });
    getFieldDecorator("totalPercepcion", {
      initialValue: this.props.formValues.totalPercepcion,
    });
    getFieldDecorator("idTipoComprobanteImportado", {
      initialValue: this.props.formValues.idTipoComprobanteImportado,
    });

    getFieldDecorator("flagReferencia", {
      initialValue: false,
    });

    getFieldDecorator("flagAmazonia", {
      initialValue: this.props.formValues.flagAmazonia
    })

    getFieldDecorator("flagDocumentoEnviado", {
      initialValue: this.props.formValues.flagDocumentoEnviado
    })

    getFieldDecorator("flagAnticipo", {
      initialValue: this.props.formValues.flagAnticipo,
    });

    getFieldDecorator("idMedidaAnticipo", {
      initialValue: this.props.formValues.idMedidaAnticipo,
    });

    getFieldDecorator("flagRegularizacion", {
      initialValue: this.props.formValues.flagRegularizacion,
    });

    getFieldDecorator("flagDescuentoGlobal", {
      initialValue: this.props.formValues.flagDescuentoGlobal,
    });

    getFieldDecorator("importeDescuentoGlobal", {
      initialValue: this.props.formValues.importeDescuentoGlobal,
    });
    getFieldDecorator("porcentajeDescuentoGlobal", {
      initialValue: this.props.formValues.porcentajeDescuentoGlobal,
    });

    getFieldDecorator("flagCuota", {
      initialValue: false,
    });

    getFieldDecorator("flagMetodoPago", {
      initialValue: false,
    });


    getFieldDecorator("flagGuiaRemisionGeneraSalidas", {
      initialValue: this.props.formValues.flagGuiaRemisionGeneraSalidas,
    });

    getFieldDecorator("idFormaPago", {
      initialValue: this.props.formValues.idFormaPago,
    });

    getFieldDecorator("idPendiente", {
      initialValue: this.props.formValues.idPendiente,
    });

    getFieldDecorator("idEstablecimientoClienteEdit", {
      initialValue: this.props.formValues.idEstablecimientoClienteEdit,
    });

    getFieldDecorator("direccionCliente", {
      initialValue: this.props.formValues.direccionCliente,
    });

    getFieldDecorator("flagEditDireccionCliente", {
      initialValue: false,
    });
    getFieldDecorator("flagImpuesto", {
      initialValue: this.props.formValues.flagImpuesto,
    });

    getFieldDecorator("idTipoPrecio", {
      initialValue: this.props.formValues.idTipoPrecio,
    });

    getFieldDecorator("codigoMoneda", {
      initialValue: this.props.formValues.idMoneda == SOLES ? 'PEN' : 'USD',
    });

    getFieldDecorator("flagPago", {
      initialValue: false,
    });


    var title = "";

    if (this.props.formValues.idTipoComprobante === FACTURA.ID)
      title = "Factura";
    if (this.props.formValues.idTipoComprobante === BOLETA_DE_VENTA.ID)
      title = "Boleta";


    const listaMedidaAnticipo = [{ id: 2, nombre: 'SERVICIOS' }, { id: 1, nombre: 'BIENES' }];

    return (
      <Modal
        title={
          this.props.formValues.id === 0
            ? `Registrar ${title}`
            : `Modificar ${title}`
        }
        visible={this.props.visible}
        onCancel={(properties) => {
          if (
            !properties.target.className.toString().match("ant-modal-wrap") ||
            properties.type === "keydown"
          )
            this.handleCancel();
        }}
        footer={[
          <Button key="cancel" onClick={this.handleCancel}>
            Cancelar
          </Button>,
          <Button
            key="ok"
            type="primary"
            loading={this.props.saveLoading}
            onClick={this.handleOk}
          >
            Guardar
          </Button>,
        ]}
        style={{ top: 30 }}
        width="1100px"
      >
        <BarcodeReader onError={this.handleError} onScan={this.handleScan} />

        <Form>
          <div className="row">
            {flagFecha ?
              (
                <div className="col-md-3 form-group">
                  <Form.Item label="Fecha / Tipo de Cambio">
                    <InputGroup compact>
                      <Form.Item style={{ width: "10%" }}>
                        {getFieldDecorator("flagPermisoFC", {
                          initialValue: this.props.formValues.flagPermisoFC,
                          valuePropName: "checked",
                        })(
                          <Checkbox
                            onChange={(e) =>
                              this.props.onChange(
                                "flagPermisoFC",
                                e.target.checked,
                                this.props.form
                              )
                            }
                          ></Checkbox>
                        )}
                      </Form.Item>
                      <Form.Item style={{ width: "60%" }}>
                        {getFieldDecorator("fechaStr", {
                          initialValue: moment(
                            this.props.formValues.fechaStr,
                            "DD/MM/YYYY"
                          ),
                          rules: [
                            {
                              type: "object",
                              required: true,
                              message: "Requerido",
                            },
                          ],
                        })(
                          <DatePicker
                            className="first-input"
                            placeholder="Seleccione fecha"
                            prefix={
                              <Icon
                                type="filter"
                                style={{ color: "rgba(0,0,0,.25)" }}
                              />
                            }
                            disabled={this.props.formValues.flagDisableFecha}
                            format="DD/MM/YYYY"
                            onChange={(moment, value) =>
                              this.props.onChange(
                                "fechaStr",
                                value,
                                this.props.form
                              )
                            }
                          />
                        )}
                      </Form.Item>
                      <Form.Item style={{ width: "30%" }}>
                        {getFieldDecorator("tipoCambio", {
                          initialValue: parseFloat(
                            this.props.formValues.tipoCambio
                          ).toFixed(3),
                          rules: [
                            {
                              required: true,
                              pattern: new RegExp(FORMAT_3DECIMALS),
                              message: "Formato decimal incorrecto (0.000)",
                            },
                          ],
                        })(
                          <Input
                            className="text-right second-input"
                            placeholder="Ingresar Tipo de Cambio"
                            autoComplete="off"
                            onBlur={(e) =>
                              this.handleCompleteDecimals(
                                "tipoCambio",
                                e.target.value
                              )
                            }
                          />
                        )}
                      </Form.Item>
                    </InputGroup>
                  </Form.Item>
                </div>
              ) :

              (<div className="col-md-3 form-group">
                <Form.Item label="Fecha / Tipo de Cambio">
                  <InputGroup compact>
                    <Form.Item style={{ width: "65%" }}>
                      {getFieldDecorator("fechaStr", {
                        initialValue: moment(
                          this.props.formValues.fechaStr,
                          "DD/MM/YYYY"
                        ),
                        rules: [
                          {
                            type: "object",
                            required: true,
                            message: "Requerido",
                          },
                        ],
                      })(
                        <DatePicker
                          className="first-input"
                          placeholder="Seleccione fecha"
                          prefix={
                            <Icon
                              type="filter"
                              style={{ color: "rgba(0,0,0,.25)" }}
                            />
                          }
                          disabled={this.props.formValues.flagDisableFecha}
                          format="DD/MM/YYYY"
                          onChange={(moment, value) =>
                            this.props.onChange(
                              "fechaStr",
                              value,
                              this.props.form
                            )
                          }
                        />
                      )}
                    </Form.Item>
                    <Form.Item style={{ width: "35%" }}>
                      {getFieldDecorator("tipoCambio", {
                        initialValue: parseFloat(
                          this.props.formValues.tipoCambio
                        ).toFixed(3),
                        rules: [
                          {
                            required: true,
                            pattern: new RegExp(FORMAT_3DECIMALS),
                            message: "Formato decimal incorrecto (0.000)",
                          },
                        ],
                      })(
                        <Input
                          className="text-right second-input"
                          placeholder="Ingresar Tipo de Cambio"
                          autoComplete="off"
                          onBlur={(e) =>
                            this.handleCompleteDecimals(
                              "tipoCambio",
                              e.target.value
                            )
                          }
                        />
                      )}
                    </Form.Item>
                  </InputGroup>
                </Form.Item>
              </div>
              )}
            {flagContingencia ? (
              <div className="col-md-3 form-group">
                <Form.Item label="Contingencia / Serie / Documento">
                  <InputGroup compact>
                    <Form.Item style={{ width: "10%" }}>
                      {getFieldDecorator("flagContingencia", {
                        initialValue: this.props.formValues.flagContingencia,
                        valuePropName: "checked",
                      })(
                        <Checkbox
                          onChange={(e) =>
                            this.props.onChange(
                              "flagContingencia",
                              e.target.checked,
                              this.props.form
                            )
                          }
                        ></Checkbox>
                      )}
                    </Form.Item>
                    <Form.Item style={{ width: "30%" }}>
                      {getFieldDecorator("serie", {
                        initialValue: this.props.formValues.serie,
                        rules: [
                          {
                            required: true,
                            message: "Requerido",
                            whitespace: true,
                          },
                          {
                            validator: this.serieCustomValidation,
                          },
                        ],
                      })(
                        <Input
                          disabled={
                            this.props.formValues.flagDisableSerieDocumento
                          }
                          placeholder="Serie"
                          autoComplete="off"
                          className="first-input"
                          onBlur={this.completeSerie}
                        />
                      )}
                    </Form.Item>
                    <Form.Item style={{ width: "60%" }}>
                      {getFieldDecorator("documento", {
                        initialValue: this.props.formValues.documento,
                        rules: [
                          {
                            validator: this.documentoCustomValidation,
                          },
                        ],
                      })(
                        <Input
                          disabled={
                            this.props.formValues.flagDisableSerieDocumento
                          }
                          placeholder="Documento"
                          autoComplete="off"
                          className="second-input"
                          onBlur={this.completeDocumento}
                          maxLength={8}
                        />
                      )}
                    </Form.Item>
                  </InputGroup>
                </Form.Item>
              </div>
            ) : (
              <div className="col-md-3 form-group">
                <Form.Item label="Serie / Documento">
                  <InputGroup compact>
                    <Form.Item style={{ width: "40%" }}>
                      {getFieldDecorator("serie", {
                        initialValue: this.props.formValues.serie,
                        rules: [
                          {
                            required: true,
                            message: "Requerido",
                            whitespace: true,
                          },
                          {
                            validator: this.serieCustomValidation,
                          },
                        ],
                      })(
                        <Input
                          placeholder="Serie"
                          autoComplete="off"
                          className="first-input"
                          style={{ textTransform: "uppercase" }}
                          onBlur={this.completeSerie}
                          disabled={true}
                        />
                      )}
                    </Form.Item>
                    <Form.Item style={{ width: "60%" }}>
                      {getFieldDecorator("documento", {
                        initialValue: this.props.formValues.documento,
                        rules: [
                          {
                            validator: this.documentoCustomValidation,
                          },
                        ],
                      })(
                        <Input
                          placeholder="Documento"
                          autoComplete="off"
                          className="second-input"
                          disabled={true}
                          onBlur={this.completeDocumento}
                          maxLength={8}
                        />
                      )}
                    </Form.Item>
                  </InputGroup>
                </Form.Item>
              </div>
            )}

            <div className="col-md-3 form-group">
              <Form.Item label="Días / Fecha de Vencimiento">
                <InputGroup compact>
                  <Form.Item style={{ width: "35%" }}>
                    {getFieldDecorator("diasVencimiento", {
                      initialValue: this.props.formValues.diasVencimiento,
                      rules: [
                        {
                          required: true,
                          pattern: new RegExp(FORMAT_NUMBER),
                          message: "Formato incorrecto",
                        },
                      ],
                    })(
                      <Input
                        style={{ textAlign: "right" }}
                        placeholder="Ingresar días de vencimiento"
                        autoComplete="off"
                        className="first-input"
                        onBlur={(e) =>
                          this.findDaysAndDates(
                            "diasVencimiento",
                            e.target.value
                          )
                        }
                      />
                    )}
                  </Form.Item>
                  <Form.Item style={{ width: "65%" }}>
                    {getFieldDecorator("fechaVencimientoStr", {
                      initialValue: moment(
                        this.props.formValues.fechaVencimientoStr,
                        "DD/MM/YYYY"
                      ),
                      rules: [
                        {
                          type: "object",
                          required: true,
                          message: "Requerido",
                        },
                      ],
                    })(
                      <DatePicker
                        placeholder="Seleccione fecha"
                        prefix={
                          <Icon
                            type="filter"
                            style={{ color: "rgba(0,0,0,.25)" }}
                          />
                        }
                        format="DD/MM/YYYY"
                        className="second-input"
                        onChange={(moment, value) =>
                          this.findDaysAndDates("fechaVencimientoStr", value)
                        }
                      />
                    )}
                  </Form.Item>
                </InputGroup>
              </Form.Item>
            </div>

            <div className="col-md-3 form-group">
              <Form.Item label="Moneda">
                {getFieldDecorator("idMoneda", {
                  initialValue: this.props.formValues.idMoneda
                    ? { key: this.props.formValues.idMoneda }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"Seleccione Moneda"}
                    optionFilterProp="children"
                    disabled={this.props.form.getFieldValue("flagDocumentoEnviado")}
                    onChange={(option) => {
                      this.props.onChange("idMoneda", option.key, this.props.form)
                    }}
                  >
                    {this.props.formValues.monedas.map((item) => (
                      <Option key={item.id} value={item.id} data={item.codigoSunat} >
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>
          </div>

          <div className="row">
            <div className="col-md-3 form-group">
              <Form.Item label="Establecimiento">
                {getFieldDecorator("idEstablecimiento", {
                  initialValue: this.props.formValues.idEstablecimiento
                    ? { key: this.props.formValues.idEstablecimiento }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"Seleccione Establecimiento"}
                    optionFilterProp="children"
                    disabled={this.props.form.getFieldValue("flagDocumentoEnviado")}
                    onChange={(option) => {
                      this.props.onChange(
                        "idEstablecimiento",
                        option.key,
                        this.props.form
                      );
                    }}
                  >
                    {this.props.formValues.establecimientos.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>
            <div className="col-md-3 form-group">
              <Form.Item label="Almacén">
                {getFieldDecorator("idAlmacen", {
                  initialValue: this.props.formValues.idAlmacen
                    ? { key: this.props.formValues.idAlmacen }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"Seleccione Almacén"}
                    optionFilterProp="children"
                    loading={this.props.form.almacenLoading}
                    disabled={this.props.form.getFieldValue("flagDocumentoEnviado")}
                    onChange={(option) =>
                      this.props.onChange(
                        "idAlmacen",
                        option.key,
                        this.props.form
                      )
                    }
                  >
                    {this.props.formValues.almacenes.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>
            <div className="col-md-3 form-group">
              <Form.Item label="Lista de Precio">
                {getFieldDecorator("idListaPrecio", {
                  initialValue: this.props.formValues.idListaPrecio
                    ? { key: this.props.formValues.idListaPrecio }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"Seleccione Lista de Precio"}
                    optionFilterProp="children"
                    disabled={this.props.form.getFieldValue("flagDocumentoEnviado")}

                    onChange={(option) =>
                      this.props.onChange(
                        "idListaPrecio",
                        option.key,
                        this.props.form
                      )
                    }
                  >
                    {this.props.formValues.listasPrecio.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>
            <div className="col-md-3 form-group">
              <Form.Item label="Vendedor">
                {getFieldDecorator("idVendedor", {
                  initialValue: this.props.formValues.idVendedor
                    ? { key: this.props.formValues.idVendedor }
                    : undefined,
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"Seleccione Vendedor"}
                    optionFilterProp="children"
                    disabled={this.props.form.getFieldValue("flagDocumentoEnviado")}

                  >
                    <Option key={0} value={0}>
                      <span style={{ color: "#bfbfbf" }}>Ninguno</span>
                    </Option>
                    {this.props.formValues.vendedores.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.razonSocialEntidad}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>
          </div>

          <div className="row">
            <div className="col-md-2 form-group">
              <Form.Item label="Nro Documento">
                <InputGroup compact>
                  <Form.Item style={{ width: "100%" }}>
                    {getFieldDecorator("documentoCliente", {
                      initialValue: this.props.formValues.documentoCliente,
                      rules: [
                        {
                          required: true,
                          message: "Campo obligatorio.",
                          whitespace: true,
                        },
                      ],
                    })(
                      <Search
                        placeholder="Documento"
                        className="first-input"
                        autoComplete="off"
                        disabled={this.props.form.getFieldValue("flagDocumentoEnviado")}

                        loading={this.props.formValues.clienteLoading}
                        onSearch={(value) =>
                          this.props.onBuscarCliente(value, this.props.form)
                        }
                        maxLength={20}
                      />
                    )}
                  </Form.Item>
                </InputGroup>
              </Form.Item>
            </div>
            <div className={
              this.props.formValues.idTipoComprobante == BOLETA_DE_VENTA.ID || this.props.formValues.idTipoComprobante == FACTURA.ID
                ? "col-md-7 form-group"
                : "col-md-7 form-group"
            } >
              <Form.Item label="Cliente">
                <InputGroup compact>

                  <Form.Item style={{ width: "100%" }}>
                    <InputGroup compact style={{ marginBottom: "1px" }}>
                      {getFieldDecorator("idCliente", {
                        initialValue: this.props.formValues.idCliente
                          ? { key: this.props.formValues.idCliente }
                          : undefined,
                        rules: [
                          {
                            required: true,
                            message: "Campo obligatorio.",
                          },
                        ],
                      })(
                        <Select
                          showSearch
                          labelInValue
                          style={{
                            width:
                              this.props.formValues.idTipoComprobante ===
                                FACTURA.ID ||
                                this.props.formValues.idTipoComprobante ===
                                BOLETA_DE_VENTA.ID
                                ? `calc(100% - 80px)`
                                : `calc(100% - 40px)`,
                            borderTopLeftRadius: "0px",
                          }}
                          placeholder={"Búsqueda de Cliente"}
                          optionFilterProp="children"
                          notFoundContent={this.props.fetching ? <Spin size="small" /> : null}
                          filterOption={false}
                          disabled={this.props.form.getFieldValue("flagDocumentoEnviado")}

                          onSearch={this.handleSearchAutocompleteCliente}
                          onChange={this.handleChangeAutocompleteCliente}
                        //onSearch={this.props.fetchClientes}
                        >
                          {getFieldValue("clientes").map((item) => (
                            <Option key={item.id} value={item.id} data={item}>
                              <Tag>{item.tipoDocumentoNombre}</Tag>
                              {`${item.nombre}`}
                            </Option>
                          ))}
                        </Select>
                      )}
                      <Button
                        className="btn-autocomplete"
                        style={{ width: "40px", fontSize: "14px" }}
                        icon={
                          this.props.form.getFieldValue("idCliente")
                            ? "close"
                            : "search"
                        }
                        onClick={() => {
                          this.props.form.setFieldsValue(
                            {
                              idCliente: undefined,
                              documentoCliente: "",
                              direccionCliente: "",
                              idEstablecimientoCliente: undefined,
                            },
                            () => {
                              this.props.onChange("direcciones-clear");
                            }
                          );
                        }}
                      />
                      <Button
                        hidden={
                          this.props.formValues.idTipoComprobante ===
                            FACTURA.ID ||
                            this.props.formValues.idTipoComprobante ===
                            BOLETA_DE_VENTA.ID
                            ? false
                            : true
                        }
                        className="btn-autocomplete"
                        style={{ width: "40px", fontSize: "14px" }}
                        icon={"plus"}
                        onClick={() => {
                          this.props.onNewCliente(
                            this.props.form.setFieldsValue,
                            this.props.form.getFieldValue
                          );
                        }}
                      />
                    </InputGroup>
                  </Form.Item>
                </InputGroup>
              </Form.Item>
            </div>

            <div className="col-md-3 form-group"  >
              <Form.Item label="IGV">
                {getFieldDecorator("otroImpuesto", {
                  initialValue: this.props.formValues.otroImpuesto
                    ? { key: this.props.formValues.otroImpuesto }
                    : undefined,
                  rules: [
                    {
                      required: false,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"IGV"}
                    optionFilterProp="children"
                    onChange={(option) => this.props.onChange("otroImpuesto", option.key, this.props.form)}
                  >
                    {this.props.formValues.Tipoimpuesto.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>


          </div>

          <div className="row">
            <div
              className={
                this.props.formValues.idTipoComprobante != BOLETA_DE_VENTA.ID
                  ? "col-md-6 form-group"
                  : "col-md-9 form-group"
              }
            >
              <Form.Item label="Dirección">
                <InputGroup compact>
                  <Form.Item style={{ width: "100%" }}>
                    {this.props.form.getFieldValue(
                      "flagEditDireccionCliente"
                    ) ? (
                      <InputGroup compact style={{ marginBottom: "1px" }}>
                        {getFieldDecorator("direccionCliente", {
                          initialValue: this.props.formValues.direccionCliente,
                        })(
                          <Input
                            style={{
                              width: `calc(100% - 40px)`,
                              borderTopLeftRadius: "0px",
                            }}
                            disabled={this.props.form.getFieldValue("flagDocumentoEnviado")}
                            placeholder="Ingresar dirección cliente"
                            autoComplete="off"
                          />
                        )}
                        <Button
                          className="btn-autocomplete"
                          style={{ width: "40px", fontSize: "14px" }}
                          icon="close"
                          onClick={() => {

                            this.props.form.setFieldsValue({
                              flagEditDireccionCliente: false,
                            });
                          }}
                        />
                      </InputGroup>
                    ) : (
                      <InputGroup compact style={{ marginBottom: "1px" }}>
                        {getFieldDecorator("idEstablecimientoCliente", {
                          initialValue: this.props.formValues
                            .idEstablecimientoCliente
                            ? {
                              key: this.props.formValues
                                .idEstablecimientoCliente,
                            }
                            : undefined,
                          rules: [
                            {
                              required: true,
                              message: "Campo obligatorio.",
                            },
                          ],
                        })(
                          <Select
                            showSearch
                            labelInValue
                            placeholder={"Seleccione Direccion"}
                            disabled={this.props.form.getFieldValue("flagDocumentoEnviado")}

                            style={{
                              width: `calc(100% - 40px)`,
                              borderTopLeftRadius: "0px",
                            }}
                            onChange={(option, row) => {
                              this.props.form.setFieldsValue({
                                direccionCliente: row.props.direccion,
                              });
                            }}
                            optionFilterProp="children"
                          >
                            {this.props.formValues.direcciones.map((item) => (
                              <Option
                                key={item.id}
                                value={item.id}
                                direccion={item.direccion}
                              >
                                {item.nombre + " - " + item.direccion}
                              </Option>
                            ))}
                          </Select>
                        )}
                        <Button
                          className="btn-autocomplete"
                          style={{ width: "40px", fontSize: "14px" }}
                          icon="edit"
                          disabled={
                            this.props.form.getFieldValue(
                              "idEstablecimientoCliente"
                            )
                              ? false
                              : true
                          }
                          onClick={() => {

                            var idEstablecimientoClienteEdit =
                              this.props.form.getFieldValue(
                                "idEstablecimientoCliente"
                              ).key;
                            this.props.form.setFieldsValue({
                              idEstablecimientoClienteEdit:
                                idEstablecimientoClienteEdit,
                              flagEditDireccionCliente: true,
                            });
                          }}
                        />
                      </InputGroup>
                    )}
                  </Form.Item>
                </InputGroup>
              </Form.Item>
            </div>

            {BOLETA_DE_VENTA.ID != this.props.formValues.idTipoComprobante ? (
              <div className="col-md-3 form-group">
                <Form.Item label="Forma de Pago">
                  {getFieldDecorator("idFormaPago", {
                    initialValue: this.props.formValues.idFormaPago
                      ? { key: this.props.formValues.idFormaPago }
                      : undefined,
                    rules: [
                      {
                        required: true,
                        message: "Campo obligatorio.",
                      },
                    ],
                  })(
                    <Select
                      disabled={this.props.formValues.idDocumentoImportadoCredito != 0 && [8, 9].includes(this.props.formValues.idTipoComprobante) || this.props.form.getFieldValue("flagAnticipo") || this.props.form.getFieldValue("flagDocumentoEnviado")}
                      showSearch
                      labelInValue
                      placeholder={"Seleccione Forma Pago"}
                      optionFilterProp="children"
                      onChange={(option) =>
                        this.props.onChange(
                          "idFormaPago",
                          option.key,
                          this.props.form
                        )
                      }
                    >
                      {this.props.formValues.formasPago.map((item) => (
                        <Option key={item.id} value={item.id}>
                          {item.nombre}
                        </Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
              </div>
            ) : null}

            {[FACTURA.ID, BOLETA_DE_VENTA.ID].includes(this.props.formValues.idTipoComprobante) ? (
              <div className="col-md-3 form-group">
                <Form.Item label="Anticipo">
                  <InputGroup compact>
                    <Form.Item style={{ width: "20%" }}>
                      {getFieldDecorator("flagAnticipo", {
                        initialValue: this.props.formValues.flagAnticipo,
                        valuePropName: "checked",
                      })(
                        <Checkbox
                          disabled={this.props.form.getFieldValue('flagRegularizacion') || this.props.form.getFieldValue("flagDocumentoEnviado")}
                          onChange={(e) => this.handleChangeTotals("flagAnticipo", e.target.checked)}
                        ></Checkbox>
                      )}
                    </Form.Item>
                    {this.props.form.getFieldValue("flagAnticipo") ? (

                      <Form.Item style={{ width: "80%" }}>
                        {getFieldDecorator("idMedidaAnticipo", {
                          initialValue: this.props.formValues.idMedidaAnticipo
                            ? { key: this.props.formValues.idMedidaAnticipo }
                            : undefined,
                          rules: [
                            {
                              required: false,
                              message: "Campo obligatorio.",
                            },
                          ],
                        })(
                          <Select
                            showSearch
                            labelInValue
                            placeholder={"Seleccione Tipo"}
                            optionFilterProp="children"
                            onChange={(option) => this.props.onChange("idMedidaAnticipo", option.key, this.props.form)}
                          >
                            {listaMedidaAnticipo.map((item) => (
                              <Option key={item.id} value={item.id}>
                                {item.nombre}
                              </Option>
                            ))}
                          </Select>
                        )}
                      </Form.Item>

                    ) : null}


                  </InputGroup>
                </Form.Item>
              </div>

            ) : null}

            {BOLETA_DE_VENTA.ID == this.props.formValues.idTipoComprobante || FACTURA.ID == this.props.formValues.idTipoComprobante ? (
              <div className="col-md-3 form-group" hidden={true} >
                <Form.Item label="Estado de Pago">
                  {getFieldDecorator("idPendiente", {
                    initialValue: this.props.formValues.idPendiente
                      ? { key: this.props.formValues.idPendiente }
                      : undefined,
                    rules: [
                      {
                        required: false,
                        message: "Campo obligatorio.",
                      },
                    ],
                  })(
                    <Select
                      showSearch
                      /*  disabled={this.props.isPendiente} */
                      disabled={true}

                      labelInValue
                      placeholder={"Pendiente de Pago"}
                      optionFilterProp="children"
                      onChange={(option) => this.props.onChange("idPendiente", option.key, this.props.form)}
                    >
                      {this.props.formValues.pendientePago.map((item) => (
                        <Option key={item.id} value={item.id}>
                          {item.nombre}
                        </Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
              </div>
            ) : null}
          </div>

          <div className="row">

            <div className={this.displaySizeObservacion()}>
              <Form.Item label="Observación">
                {getFieldDecorator("observacion", {
                  initialValue: this.props.formValues.observacion,
                  rules: [
                    {
                      required: false,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Input
                    placeholder="Ingresar Observación"
                    autoComplete="off"
                  />
                )}
              </Form.Item>
            </div>
            {this.props.formValues.flagEmpresaGrifo && [FACTURA.ID, BOLETA_DE_VENTA.ID].includes(this.props.formValues.idTipoComprobante) ? (
              <div className="col-md-3 form-group">
                <Form.Item label="N° Placa">
                  {getFieldDecorator("numeroPlaca", {
                    initialValue: this.props.formValues.numeroPlaca,
                  })(
                    <Input placeholder="Ingresar N° Placa" autoComplete="off" />
                  )}
                </Form.Item>
              </div>
            ) : null}

            {this.props.formValues.flagEmpresaTaller && [FACTURA.ID, BOLETA_DE_VENTA.ID].includes(this.props.formValues.idTipoComprobante) ? (
              <>
                <div className="col-md-7 form-group">
                  <Form.Item label="Encargado">
                    {getFieldDecorator("encargado", {
                      initialValue: this.props.formValues.encargado,
                    })(
                      <Input placeholder="Ingresar Encargado" autoComplete="off" />
                    )}
                  </Form.Item>
                </div>

                <div className="col-md-5 form-group">
                  <Form.Item label="Vehículo">
                    {getFieldDecorator("idVehiculo", {
                      initialValue: this.props.formValues.idVehiculo
                        ? { key: this.props.formValues.idVehiculo }
                        : undefined,
                      rules: [
                        {
                          required: false,
                          message: "Campo obligatorio.",
                        },
                      ],
                    })(
                      <Select
                        showSearch
                        labelInValue
                        placeholder={"Seleccione Placa"}
                        optionFilterProp="children"
                      >
                        {this.props.formValues.vehiculos.map((item) => (
                          <Option key={item.id} value={item.id}>
                            {item.placa + ' (' + item.marca + '-' + item.modelo + ')'}
                          </Option>
                        ))}
                      </Select>
                    )}
                  </Form.Item>
                </div>
              </>


            ) : null}

            <div className="col-md-3 form-group">
              <Form.Item label="Proyecto">
                {getFieldDecorator('idProyecto', {
                  initialValue: this.props.formValues.idProyecto ?
                    { key: this.props.formValues.idProyecto } : 0
                })(
                  <Select showSearch labelInValue
                    placeholder={"Seleccione Proyecto"}
                    optionFilterProp="children"
                  >
                    <Option key={0} value={0}>
                      <span style={{ color: "#bfbfbf" }}>Ninguno</span>
                    </Option>
                    {this.props.formValues.proyectos.map(item => (
                      item.estado ?
                        <Option key={item.id} value={item.id}>{item.nombre}</Option>
                        : null
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>
            {this.props.formValues.flagGiroNegocio ?

              <div className="col-md-6 form-group">
                <Form.Item label="Obra">
                  {getFieldDecorator("giroNegocio", {
                    initialValue: this.props.formValues.giroNegocio,
                  })(
                    <Input placeholder="Ingresar Obra" autoComplete="off" />
                  )}
                </Form.Item>
              </div> : null
            }

            {this.props.formValues.flagClaim ?

              <div className="col-md-3 form-group">
                <Form.Item label="Número de Orden">
                  {getFieldDecorator('nroOrden', {
                    initialValue: this.props.formValues.nroOrden
                  })(
                    <Input
                      placeholder="Ingresar Numero de Orden"
                      autoComplete="off"
                    />
                  )}
                </Form.Item>
              </div>
              : null
            }

            {[FACTURA.ID, BOLETA_DE_VENTA.ID].includes(this.props.formValues.idTipoComprobante)
              && this.props.formValues.idFormaPago == CONTADO && this.props.formValues.flagCobranzaDirecta ? (
              <>
                <div className="col-md-3 form-group">
                  <Form.Item label="Realizar Pago">
                    <InputGroup compact>
                      <Form.Item style={{ width: "10%" }}>
                        {getFieldDecorator("flagPago", {
                          initialValue: this.props.formValues.flagPago,
                          valuePropName: "checked",
                        })(
                          <Checkbox
                            disabled={this.props.form.getFieldValue("flagDocumentoEnviado") || this.props.form.getFieldValue("flagAnticipo")}
                            onChange={(e) => {
                              this.props.form.setFieldsValue({
                                flagPago: !e.target.checked,
                                idCaja: undefined,
                              });
                            }}
                          ></Checkbox>
                        )}
                      </Form.Item>

                      <Form.Item style={{ width: "90%" }}>
                        {getFieldDecorator("idCaja", {
                          initialValue: this.props.formValues.idCaja
                            ? { key: this.props.formValues.idCaja }
                            : undefined,
                          rules: [
                            {
                              required: this.props.form.getFieldValue("flagPago"),
                              message: "Campo obligatorio.",
                            },
                          ],
                        })(
                          <Select
                            labelInValue
                            placeholder={"Seleccione Caja"}
                            optionFilterProp="children"
                            disabled={!this.props.form.getFieldValue("flagPago")}
                            onChange={(option) => this.props.onChange("idCaja", option.key, this.props.form)}
                          >
                            {this.props.formValues.caja.map((item) => (
                              <Option key={item.id} value={item.id}>
                                {item.nombre}
                              </Option>
                            ))}
                          </Select>
                        )}
                      </Form.Item>
                    </InputGroup>
                  </Form.Item>
                </div>

              </>
            ) : null}

            {auth.user().parametros.filter((m) => m.abreviatura == "PAGRO")[0].valor == "1" ? (

              <>
                <div className="col-md-3 form-group">
                  <Form.Item label="Cultivo">
                    {getFieldDecorator('idCultivo', {
                      initialValue: this.props.formValues.idCultivo
                        ? { key: this.props.formValues.idCultivo }
                        : undefined,
                      rules: [
                        {
                          required: true,
                          message: "Campo obligatorio.",
                        },
                      ],
                    })(
                      <Select showSearch labelInValue
                        placeholder={"Seleccione Cultivo"}
                        optionFilterProp="children"
                        onChange={(option) => {
                          this.props.onChange(
                            "idCultivo",
                            option.key,
                            this.props.form
                          );
                        }}
                      >
                        {this.props.formValues.cultivos.map(item => (
                          <Option key={item.id} value={item.id}>{item.nombre}</Option>
                        ))}
                      </Select>
                    )}
                  </Form.Item>
                </div>

                <div className="col-md-3 form-group">
                  <Form.Item label="Etapa Fenológica">
                    {getFieldDecorator('idFenologica', {
                      initialValue: this.props.formValues.idFenologica
                        ? { key: this.props.formValues.idFenologica }
                        : undefined,
                      rules: [
                        {
                          required: true,
                          message: "Campo obligatorio.",
                        },
                      ],
                    })(
                      <Select showSearch labelInValue
                        placeholder={"Seleccione Etapa Fenológica"}
                        optionFilterProp="children"
                      >
                        {this.props.formValues.fenologicas.map(item => (
                          <Option key={item.id} value={item.id}>{item.nombre}</Option>
                        ))}
                      </Select>
                    )}
                  </Form.Item>
                </div>
              </>
            ) : null}

          </div>

          <div className="row">
            {[FACTURA.ID, BOLETA_DE_VENTA.ID].includes(
              this.props.formValues.idTipoComprobante
            ) ? (
              <div className="col-md-2 form-group">
                <Button
                  icon="plus"
                  type="primary"
                  style={{ margin: '3px' }}
                  disabled={this.props.form.getFieldValue("flagAnticipo") || this.props.form.getFieldValue("flagDocumentoEnviado")}
                  onClick={() =>
                    this.props.onImportarAnticipo(
                      this.props.form.setFieldsValue,
                      this.props.form.getFieldValue
                    )
                  }
                >
                  Importar Anticipo
                </Button>
              </div>
            ) : null}

            {[FACTURA.ID, BOLETA_DE_VENTA.ID].includes(
              this.props.formValues.idTipoComprobante
            ) ? (
              <div className="col-md-2 form-group">
                <Button
                  icon="plus"
                  type="primary"
                  style={{ margin: '3px' }}
                  disabled={this.props.form.getFieldValue("flagAnticipo") || this.props.form.getFieldValue("flagDocumentoEnviado")}
                  onClick={() =>
                    this.props.onImportarPedido(
                      this.props.form.setFieldsValue,
                      this.props.form.getFieldValue
                    )
                  }
                >
                  Importar Pedidos
                </Button>
              </div>
            ) : null}
            {[FACTURA.ID, BOLETA_DE_VENTA.ID].includes(
              this.props.formValues.idTipoComprobante
            ) ? (
              <div className="col-md-2 form-group">
                <Button
                  icon="plus"
                  type="primary"
                  style={{ margin: '3px' }}
                  disabled={this.props.form.getFieldValue("flagAnticipo") || this.props.form.getFieldValue("flagDocumentoEnviado")}
                  onClick={() =>
                    this.props.onImportarCotizacion(
                      this.props.form.setFieldsValue,
                      this.props.form.getFieldValue
                    )
                  }
                >
                  Importar Cotización
                </Button>
              </div>
            ) : null}
            {this.props.formValues.flagGuiaImportar ? (
              <div className="col-md-2 form-group">
                <Button
                  icon="plus"
                  type="primary"
                  disabled={this.props.form.getFieldValue("flagDocumentoEnviado")}
                  style={{ margin: '3px' }}
                  onClick={() =>
                    this.props.onImportarGuiaRemision(
                      this.props.form.setFieldsValue,
                      this.props.form.getFieldValue
                    )
                  }
                >
                  Importar Guía de Remisión
                </Button>
              </div>
            ) : null}

          </div>
          <div className="row">
            <div className="col-md-12 form-group">
              <Tabs
                activeKey={this.props.formValues.activeKey}
                onChange={(key) => this.props.onChangeTab(key, setFieldsValue)}
                tabBarExtraContent={
                  <div className="custom-options">
                    <Button
                      icon="plus"
                      type="primary"
                      disabled={this.props.form.getFieldValue("flagAnticipo") || this.props.form.getFieldValue("flagDocumentoEnviado")}
                      onClick={() =>
                        this.props.onAgregarDetalle(
                          this.props.form.setFieldsValue,
                          this.props.form.getFieldValue
                        )
                      }
                    >
                      Agregar
                    </Button>

                    {[FACTURA.ID, BOLETA_DE_VENTA.ID].includes(this.props.formValues.idTipoComprobante) && auth.user().planCode == "PLA001" ? (
                      <Button
                        icon="plus"
                        type="primary"
                        disabled={this.props.form.getFieldValue("flagAnticipo") || this.props.form.getFieldValue("flagDocumentoEnviado")}
                        onClick={() => this.props.OnItemLibre(this.props.form.setFieldsValue, this.props.form)}
                      >
                        Agregar item libre
                      </Button>
                    ) : null}


                  </div>
                }
              >
                <TabPane
                  tab={
                    <span>
                      <Icon type="ordered-list" />
                      Detalle de Productos y Servicios
                    </span>
                  }
                  key="1"
                >
                  {seriePorProducto == 1 ?
                    <div className="col-md-12 form-group" style={{ marginLeft: -20 }}>
                      <div className="col-md-12 form-group">
                        <Form.Item>
                          {getFieldDecorator('flagTipoBusquedaScanner', {
                            initialValue: this.props.formValues.flagTipoBusquedaScanner
                          })(
                            <Radio.Group name="radiogroup"
                            // onChange={(e) => this.props.onChangeForm("flagTipoBusquedaScanner", e.target.value, this.props.form)}
                            >
                              <Radio value={0}>Búsqueda por código de barra</Radio>
                              <Radio value={1}>Búsqueda por serie</Radio>
                            </Radio.Group>
                          )}
                        </Form.Item>
                      </div>
                    </div> : null
                  }
                  <Productos
                    dataSource={this.props.formValues.listaComprobanteDetalle}
                    precioUnitarioDisabled={
                      this.props.formValues.precioUnitarioDetailDisabled
                    }
                    totalDisabled={this.props.formValues.totalDetailDisabled}
                    onRemove={this.handleRemoverProducto}
                    onAgregarSerie={this.props.onAgregarSerie}
                    onEditarNombreProducto={this.props.onEditarNombreProducto}
                    onCalculateDetail={this.handleCalculateDetail}
                    onGetFieldDecorator={getFieldDecorator}
                    onSetFieldsValue={setFieldsValue}
                    onGetFieldValue={getFieldValue}
                    flagTributosIguales={this.state.flagTributosIguales}
                    unidadesMedida={this.props.formValues.unidadesMedida}
                    tipoAfectacion={this.props.formValues.tipoAfectacion}
                    handleSelectConversion={this.props.handleSelectConversion}
                    tipoComprobante={[FACTURA.ID].includes(this.props.formValues.idTipoComprobante)}
                    isMobile={this.state.isMobile}

                  />
                </TabPane>
                <TabPane
                  tab={
                    <span>
                      <Icon type="unordered-list" /> Detalle de Referencias
                    </span>
                  }
                  key="2"
                >
                  <Referencias
                    dataSource={
                      this.props.formValues.listaComprobanteReferencia
                    }
                    tiposComprobante={this.props.formValues.tiposComprobante}
                    onRemove={this.props.onRemoverReferencia}
                    onGetFieldDecorator={getFieldDecorator}
                  />
                </TabPane>
                {this.props.formValues.idTipoComprobante != BOLETA_DE_VENTA.ID && this.props.formValues.idFormaPago == 2 ? (
                  <TabPane
                    visible={false}
                    tab={
                      <span>
                        <Icon type="unordered-list" /> Detalle de Cuotas
                      </span>
                    }
                    key="3"
                  >
                    <Cuotas

                      dataSource={this.props.formValues.listaComprobanteCuota}
                      onRemove={this.props.onRemoverCuota}
                      onGetFieldDecorator={getFieldDecorator}
                    />
                  </TabPane>
                ) : null}


                {([FACTURA.ID, BOLETA_DE_VENTA.ID].includes(this.props.formValues.idTipoComprobante)
                  && this.props.form.getFieldValue("flagPago") && this.props.formValues.flagCobranzaDirecta)
                  && this.props.formValues.idFormaPago == CONTADO ? (
                  <TabPane

                    tab={
                      <span>
                        <Icon type="unordered-list" /> Método de Pago
                      </span>
                    }
                    key="4"
                  >
                    <MetodoPago
                      dataSource={this.props.formValues.listaComprobanteMetodoPago}
                      metodosPagos={this.props.formValues.metodosPagos}
                      cuentas={this.props.formValues.cuentas}
                      onRemove={this.props.onRemoverMetodoPago}
                      onGetFieldDecorator={getFieldDecorator}
                      onSetFieldsValue={setFieldsValue}
                    />
                  </TabPane>

                ) : null}

                {([FACTURA.ID, BOLETA_DE_VENTA.ID].includes(this.props.formValues.idTipoComprobante)
                  && auth.user().planCode != "PLA003")
                  && this.props.formValues.idFormaPago == CONTADO ? (
                  <TabPane

                    tab={
                      <span>
                        <Icon type="unordered-list" /> Método de Pago
                      </span>
                    }
                    key="4"
                  >
                    <MetodoPago
                      dataSource={this.props.formValues.listaComprobanteMetodoPago}
                      metodosPagos={this.props.formValues.metodosPagos}
                      cuentas={this.props.formValues.cuentas}
                      onRemove={this.props.onRemoverMetodoPago}
                      onGetFieldDecorator={getFieldDecorator}
                      onSetFieldsValue={setFieldsValue}
                    />
                  </TabPane>

                ) : null}



              </Tabs>
            </div>
          </div>
          <Footer
            formValues={this.props.formValues}
            onChangeTotals={this.handleChangeTotals}
            onGetFieldDecorator={getFieldDecorator}
            onSetFieldsValue={setFieldsValue}
            onGetFieldValue={getFieldValue}
            flagTributosIguales={this.state.flagTributosIguales}
          />
        </Form>
      </Modal >
    );
  }
}
export default Form.create()(FormModal);
